export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Escrime XII - Issue 120",
    "shortTitle": "",
    "description": "",
    "width": 1173,
    "height": 880,
    "currentLanguage": "EN",
    "languages": [{
      code: "EN",
      text: "English",
      href: "https://escrime-xxi.fie.org/120/en/"
    },
    {
      code: "FR",
      text: "French",
      href: "https://escrime-xxi.fie.org/120/fr/"
    },
    {
      code: "ES",
      text: "Spanish",
      href: "https://escrime-xxi.fie.org/120/es/"
    }],
    "basePath": "/120/en",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://escrime-xxi.fie.org/120/en/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '/120/en/static/_content/escrime-120-en.pdf',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": true,
      "guideEnabled": false,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 1-title" style="top:84px;left:52px;" src="/120/en/static/_content/1-title-1.png">
        <img class="abs halfScale 1-title" style="top:210px;left:52px;" src="/120/en/static/_content/1-title-2.png">
        <img class="abs halfScale 1-title" style="top:1px;left:290px;" src="/120/en/static/_content/1-numerals-1.png">
        <img class="abs halfScale 1-title" style="top:84px;left:824px;" src="/120/en/static/_content/1-ed-1.png">
        <img class="abs halfScale 1-title" style="top:84px;left:957px;" src="/120/en/static/_content/logo.png">
        <img class="abs halfScale 1-title" style="top:328px;left:50px;" src="/120/en/static/_content/1-sub-1.png">
        <img class="abs halfScale 1-title" style="top:433px;left:53px;" src="/120/en/static/_content/1-sub-2.png">
        <img class="abs halfScale 1-title" style="top:499px;left:54px;" src="/120/en/static/_content/1-sub-3.png">
      `,
      "mobileHtml": `
        <img src="/120/en/static/_content/1-mobile-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
            .staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }
      
        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "N˚120 DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  Junior and Cadet World Championships World Cup Grand Prix  Use your keyboard keys, or swipe to navigate left and right through the magazine"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 2-title" style="top:63px;left:64px;" src="/120/en/static/_content/2-title-1.png">
        <img class="abs halfScale pointer howto-desktop" style="top:96px;left:696px;" onclick="switchPopHowto(true)"
          src="/120/en/static/_content/2-btn-1.png">
        <img class="abs halfScale pointer howto-ipad" style="top:96px;left:850px;opacity:0" onclick="switchPopHowto(false)"
          src="/120/en/static/_content/2-ipad-btn.png">
        <img class="abs halfScale 2-img howto-desktop" style="top:202px;left:64px;" src="/120/en/static/_content/2-img-1.png">
        <img class="abs halfScale 2-img howto-ipad" style="top:191px;left:64px; opacity:0" src="/120/en/static/_content/2-ipad.png">
        <img class="abs halfScaleC 2-text" style="top:605px;left:39px;" src="/120/en/static/_content/2-text-1.png">
        <img class="abs halfScaleC 2-text" style="top:606px;left:220px;" src="/120/en/static/_content/2-text-2.png">
        <img class="abs halfScaleC 2-text" style="top:606px;left:508px;" src="/120/en/static/_content/2-text-3.png">
        <img class="abs halfScaleC 2-text" style="top:606px;left:776px;" src="/120/en/static/_content/2-text-4.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim
            .staggerFromTo(cOf("2-text"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1)
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop();
          resetNumbers("2-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "HOW TO USE  Click to change view  HOW TO USE Escrime XXI The Fencing Magazine uses the latest digital technology - here are some of the exciting features to enjoy.  DESKTOP  IPAD  SP ORT  MEN'S AND WOMEN'S EPEE GRAND PRIX IN BUDAPEST BUDAPEST, HUNGARY 4–6 MARCH 2022  BROWSING Use the arrows on your keypad to navigate horizontally through the magazine  Navigation To view the magazine, use the arrows on your keypad to travel left and right through the publication.  BROWSER For the best results, we recommend using Safari or Google Chrome  EXPLORE  e.. Hotspots insid  .  1 2 3 POP UPS  PLAY BUTTON  SOCIAL MEDIA  NUMBERS  Press to reveal, and hide, nuggets of information.  This magazine features great video. Pushing this will launch one.  Press the social media icons found throughout the magazine  Push the buttons to reveal more exciting content.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.absolutefencinggear.com/" target="_blank" class="contentLinkNone" style="    top: 720px; left: 430px; width: 710px; height: 60px;"></a>
      `,
      "mobileHtml": `
        <a href="https://www.absolutefencinggear.com/" target="_blank">
          <img src="/120/en/static/_content/3-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 4-title" style="top:62px;left:63px;" src="/120/en/static/_content/4-title-1.png">
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC abs halfpulse animatedpulse" style="top: 47px; left:644px;" src="/120/en/static/_content/fb-navy.png">
        </a>
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC abs halfpulse animatedpulse" style="top: 86px; left:644px;" src="/120/en/static/_content/tw-navy.png">
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
        <img id="4-next" class="halfScale pointer" style="top:719px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-sky.png">

          <img class="cont-item cont-item-1-btn halfScale" style="top:250px;left:439px;opacity:0;"
              src="/120/en/static/_content/4-popup-1-1.png">
          <img class="cont-item cont-item-2-btn halfScale" style="top:259px;left:440px;opacity:0"
            src="/120/en/static/_content/4-popup-2-1.png">
          <img class="cont-item cont-item-3-btn halfScale" style="top:259px;left:440px;opacity:0"
            src="/120/en/static/_content/4-popup-2-2.png">
          <img class="cont-item cont-item-4-btn halfScale" style="top:204px;left:440px;opacity:0"
            src="/120/en/static/_content/4-popup-3-1.png">
          <img class="cont-item cont-item-5-btn halfScale" style="top:269px;left:440px;opacity:0"
            src="/120/en/static/_content/4-popup-4-1.png">
          <img class="cont-item cont-item-6-btn halfScale" style="top:204px;left:440px;opacity:0"
            src="/120/en/static/_content/4-popup-5-1.png">
          <img class="cont-item cont-item-7-btn halfScale" style="top:251px;left:440px;opacity:0"
            src="/120/en/static/_content/4-popup-6-1.png">
          
          <div class="addContentLink" onclick="contentsBub(1);" style="top: 275px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(2);" style="top: 345px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="contentLinkNone 2-click" onclick="contentsBub(2);"
          style="top: 715px; left: 496px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 3-click" onclick="contentsBub(2);"
          style="top: 715px; left: 496px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 2-click" onclick="contentsBub(3);"
            style="top: 715px; left: 688px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 3-click" onclick="contentsBub(3);"
            style="top: 715px; left: 688px; width: 169px; height: 54px;display:none"></div>
          <div class="addContentLink" onclick="contentsBub(4);" style="top: 415px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(5);" style="top: 486px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(6);" style="top: 556px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(7);" style="top: 626px; left: 65px; width: 377px; height: 50px;"></div>
          
          <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)"
            style="top: 273px; left: 442px; width: 594px; height: 50px;display:none;"></div>

          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(10)"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(14)"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(17)"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(20)"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(22)"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(25)"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(27)"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(31)"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(33)"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(35)"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(39)"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(45)"
            style="top: 415px; left: 442px; width: 590px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-5-link"
            onclick="Publish.goToPage(47)"
            style="top: 486px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-1'), 1000})"
            style="top: 556px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-2'), 1000})"
            style="top: 626px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-1', '53-cta-1'), 1000})"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-2', '53-cta-2'), 1000})"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-3', '53-cta-3'), 1000})"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-4', '53-cta-4'), 1000})"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-5', '53-cta-5'), 1000})"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-6', '53-cta-6'), 1000})"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim
            .fromTo(cOf("4-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function contentsBub(index){
          console.log(index)
          for(var i=0; i <= 9; i++){
            if(i == index){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "";
              },0);
              [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                c.style.display = "";
              },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:1, onComplete:function(){
                
                cOf("cont-item-"+index+"-link")[0].style.display = ""
                if(cOf("cont-item-"+index+"-link")[1]){
                  cOf("cont-item-"+index+"-link")[1].style.display = "" 
                }
              }});
            }else{
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:0});
            }
          }
        }

        function onPageLeave() {
          pg4Anim.stop();
          resetNumbers("4-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "THIS ISSUE  Welcome to the latest edition of Escrime XXI, packed with the best fencing images, video and features and showcased in a striking new look.  WWW.FIE.ORG  EDITORIAL  SPORT  Tap buttons to reveal content  FIE NEWS N˚120  CONFEDERATION AND FEDERATION NEWS  DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  WORLD NEWS  Junior and Cadet World Championships World Cup Grand Prix  ORBITUARIES Use your keyboard keys, or swipe to navigate left and right through the magazine  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:info@fie.ch">
          <div class="contentLink" style="bottom: 170px; right: 526px; width: 124px; height: 21px;"></div>
        </a>
        <a href="http://www.touchline.com" target="_blank">
          <div class="contentLink" style="    bottom: 178px; right: 236px; width: 234px; height: 21px;"></div>
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLink" style="bottom: 146px; right: 568px; width: 82px; height: 21px;"></div>
        </a>

        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:775px;left:41px"
            src="/120/en/static/_content/tw-white.png">
        </a>

        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:775px;left:94px"
            src="/120/en/static/_content/fb-white.png">
        </a>

        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:775px;left:147px"
            src="/120/en/static/_content/yt-white.png">
        </a>

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <img id="5-next" class="halfScale pointer" style="top:653px;right:-80px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-sky.png">
      `,
      "mobileHtml": `
        <p><strong>Interim President:</strong><br>Emmanuel Katsiadakis (M.H.) (GRE)
          <br><strong>Secretary Treasurer:</strong><br>Ferial Nadira Salhi (ALG)
        </p>
        <p><strong>Vice Presidents:</strong><br>Erika Aze (LAT)<br>Ana Irene Delgado
          Guerra (PAN)<br>Abdelmoneim Elhamy El Husseiny (EGY)</p>
        <p><strong>Members:</strong><br>Rusni Abu Hassan (MAS)<br>Donald Anthony Jr.
          (USA)<br>Paolo Azzi (ITA)<br>Bruno Gares (FRA)<br>Vadym Guttsait
          (UKR)<br>Velichka Hristeva (BUL)<br>Yuki Ota (JPN)<br>Novak Perovic
          (RSA)<br>Oleg Peskov (KAZ)<br>Haibin Wang (CHN)<br>Aldo Montano President of
          the FIE Athletes’ Commission (ITA)</p>
        <p><strong>President, African Fencing Confederation:</strong><br>Mbagnick Ndiaye
          (SEN)<br><strong>President, Pan-American Fencing
            Confederation:</strong><br>Vitaly Logvin (MEX)<br><strong>President, Asian
            Fencing Confederation:</strong><br>HH. Engr. Sheikh Salem Sultan S. Al
          Qasimi<br><strong>President, European Fencing
            Confederation:</strong><br>Stanislav Pozdnyakov (RUS)
          <br><strong>President, Oceanian Fencing Confederation:</strong><br>Helen Smith
          (M.H.) (AUS)
        </p>
        <h2 id="fie-head-office">FIE Head Office</h2>
        <p><strong>Chief Executive Officer</strong><br>Nathalie Rodriguez M.-H. (FRA)
        </p>
        <h2 id="administration">Administration</h2>
        <p><strong>Administration Director:</strong><br>Elena Murdaca
          (ITA)<br><strong>Accounting Manager:</strong><br>Sandra Baroni
          (SUI)<br><strong>Administrative Assistant:</strong><br>Ylenia Murdaca
          (ITA)<br><strong>Project Manager:</strong><br>Ekaterina Mashina (RUS)</p>
        <h2 id="sport">Sport</h2>
        <p><strong>Sport and Technical Director:</strong><br>Evgeny Tsoukhlo
          (RUS)<br><strong>Sport Technology and Administration
            Manager:</strong><br>Natalia Bodrova (RUS)<br><strong>Head of
            Operations:</strong><br>Elena Huot (RUS)</p>
        <h2 id="communication-marketing-tv">Communication, Marketing, TV</h2>
        <p><strong>Head of FIE President’s Cabinet:</strong><br>Nina Lalovic
          (SRB)<br><strong>Digital Communications Manager:</strong><br>Maria Ntanou
          (GRE)<br><strong>Head of FIE TV Production:</strong><br>Barna Heder
          (HUN)<br><strong>FIE TV Production Assistant:</strong><br>Svetlana
          Krasnokoutskaya (RUS)<br><strong>Press Officer:</strong><br>Serge Timacheff
          (USA)<br><strong>Photographer:</strong><br>Augusto Bizzi (ITA)</p>
        <h2 id="design">Design</h2>
        <p>Touchline (www.touchline.com)</p>
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim
            .fromTo(idOf("5-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop();
          resetNumbers("5-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LIST OF C OME X  FIE HEAD OFFICE  Interim President: Emmanuel Katsiadakis (M.H.) (GRE) Secretary Treasurer: Ferial Nadira Salhi (ALG)  Chief Executive Officer Nathalie Rodriguez M.-H. (FRA)  Vice Presidents: Erika Aze (LAT) Ana Irene Delgado Guerra (PAN) Abdelmoneim Elhamy El Husseiny (EGY) Members: Rusni Abu Hassan (MAS) Donald Anthony Jr. (USA) Paolo Azzi (ITA) Bruno Gares (FRA) Vadym Guttsait (UKR) Velichka Hristeva (BUL) Yuki Ota (JPN) Novak Perovic (RSA) Oleg Peskov (KAZ) Haibin Wang (CHN) Aldo Montano President of the FIE Athletes’ Commission (ITA) President, African Fencing Confederation: Mbagnick Ndiaye (SEN) President, Pan-American Fencing Confederation: Vitaly Logvin (MEX) President, Asian Fencing Confederation: HH. Engr. Sheikh Salem Sultan S. Al Qasimi President, European Fencing Confederation: Stanislav Pozdnyakov (RUS) President, Oceanian Fencing Confederation: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Administration  Administration Director: Elena Murdaca (ITA) Accounting Manager: Sandra Baroni (SUI) Administrative Assistant: Ylenia Murdaca (ITA) Project Manager: Ekaterina Mashina (RUS) Sport  Sport and Technical Director: Evgeny Tsoukhlo (RUS)  Sport Technology and Administration Manager: Natalia Bodrova (RUS) Head of Operations: Elena Huot (RUS) Communication, Marketing, TV  Head of FIE President’s Cabinet: Nina Lalovic (SRB)  Digital Communications Manager: Maria Ntanou (GRE)  Head of FIE TV Production: Barna Heder (HUN)  FIE TV Production Assistant: Svetlana Krasnokoutskaya (RUS) Press Officer: Serge Timacheff (USA) Photographer: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <img id="6-img" class="halfScale 6-text-1 6-text" style="top:168px;left:367px"
          src="/120/en/static/_content/6-img-1.png">
        <img id="6-title" class="halfScale 6-title 6-text-1 6-text" style="top:511px;left:297px"
          src="/120/en/static/_content/6-title-1.png">
        
        <img id="6-text-1" class="halfScale 6-text-1 6-text" style="top:167px;left:601px"
          src="/120/en/static/_content/6-text-1.png">
        <img id="6-text-2" class="halfScale 6-text-2 6-text" style="top:167px;left:155px; opacity:0;"
          src="/120/en/static/_content/6-text-2.png">
        
        <img id="6-cta-1" class="halfScale pointer 6-btn" style="top: 648px; left: 599px;transform: scale(0.505);"
          onclick="toggleText6(false);" src="/120/en/static/_content/6-btn-1.png">
        <img id="6-cta-2" class="halfScale pointer 6-btn" style="top: 648px; left: 813px;transform: scale(0.505);opacity:0"
          onclick="toggleText6(true);" src="/120/en/static/_content/6-btn-2.png">

        <img id="6-next" class="halfScale pointer" style="top:719px;right:-80px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-navy.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "mobileHtml": `
        <h2 id="together-we-are-fencing">Together We Are fencing</h2>
        <img src="/120/en/static/_content/6-mobile-1.jpg">
        <p><strong>Dear Friends,</strong></p>
        <p>We are pleased to bring you this issue of Escrime, covering a world of
          fencing that is once again thriving globally. In this extremely difficult
          time, the FIE expresses the wish that peace will prevail once again in the
          world and we as a global family must come together to help those most in need.
          Sport is a powerful tool for building peace, reconciliation and understanding
          to bring people together. We can and should live peacefully. </p>
        <p>We have also had to contend with the worldwide pandemic for the past two
          years. During this period, the FIE and national federations worked to ensure
          our events could go ahead as safely as possible. As a result, both World Cup
          and Grand Prix competitions successfully began and will continue throughout
          the year, with many events still to come. Likewise, we have just completed the
          2022 Junior and Cadet Fencing World Championships in Dubai, where 1357 fencers
          from 103 countries—more than ever in our history—gathered for nine days of
          peaceful yet exciting competition. </p>
        <p>Next, the Senior Fencing World Championships will be hosted in Egypt in July
          and Croatia will welcome the Veteran Fencing World Championships in October.
        </p>
        <p>Following the resounding success of fencing at the Tokyo 2020 Olympic Games,
          I believe we are in as strong a position as ever to carry on building our
          strategy to further develop and increase its popularity with a view of the
          Paris 2024 Olympic Games. The remarkable growth fencing has witnessed on
          social media, television and in global participation clearly shows we are on
          the right path to further develop our sport.</p>
        <p>Now is the time to become resourceful and innovative to build fencing at many
          levels to generate excitement and heighten awareness worldwide. We must
          continue the momentum of past years to evolve forward with strength,
          enthusiasm and optimism. </p>
        <p>I invite all of you to embrace your roles as ambassadors and stakeholders in
          our sport to become even stronger and more prominent, both in your communities
          and your fencing halls. Whether you are an athlete, coach, official, volunteer
          or fan, you each play a hugely significant role in the success of world
          fencing that simply cannot be understated. </p>
        <p>On behalf of the FIE, I would like to thank you for your continued support
          and hope you enjoy a healthy and prosperous 2022.</p>
        <p>Emmanuel Katsiadakis<br><strong>Interim President</strong></p>
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim
            .fromTo(cOf("6-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("6-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function toggleText6(bool){
          var text1 = idOf("6-text-1");
          var text2 = idOf("6-text-2");
          
          if(!bool && text1.style.opacity == "0"){
            pg6Anim.play();
            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
          }else if(bool && text2.style.opacity == "0"){
            pg6Anim.pause();
            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
          }
        }

        function onPageLeave() {
          pg6Anim.stop();
          resetNumbers("6-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "FORE WORD  Dear Friends, We are pleased to bring you this issue of Escrime, covering a world of fencing that is once again thriving globally. In this extremely difficult time, the FIE expresses the wish that peace will prevail once again in the world and we as a global family must come together to help those most in need. Sport is a powerful tool for building peace, reconciliation and understanding to bring people together. We can and should live peacefully.  TOGETHER WE ARE FENCING  We have also had to contend with the worldwide pandemic for the past two years. During this period, the FIE and national federations worked to ensure our events could go ahead as safely as possible. As a result, both World Cup and Grand Prix competitions successfully began and will continue throughout the year, with many events  PAGE 1  PAGE 2  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <a href="https://shop.pbtfencing.com/" target="_blank">
          <div class="contentLinkNone" style="bottom: 21px; right: 723px; width: 193px; height: 38px;"></div>
        </a>
        <a href="mailto:sales@pbtfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom:21px;right:505px;width:205px;height:38px;"></div>
        </a>
        <a href="https://www.instagram.com/pbt_fencing" target="_blank">
          <div class="contentLinkNone" style="bottom: 21px; right: 259px; width: 236px; height: 38px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://shop.pbtfencing.com/" target="_blank">
          <img src="/120/en/static/_content/7-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 8-title" style="top:127px;left:65px;" src="/120/en/static/_content/8-title-1.png">
        <img class="abs halfScale 8-sub" style="top:326px;left:97px;" src="/120/en/static/_content/8-sub-1.png">
        <img class="abs halfScale 8-line" style="top:324px;left:64px;" src="/120/en/static/_content/8-line-1.png">
        <img id="8-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="usa-s-gassner-italy-s-cammilletti-win-tashkent-satellite-foil-tournament">
          USA’s Gassner, Italy’s Cammilletti win Tashkent Satellite Foil Tournament</h2>
          <img src="/120/en/static/_content/8-mobile-1.jpg">
        <p><strong>Tashkent, Uzbekistan<br>29 September 2021</strong></p>
        <p><strong>USA’s Ethan Gassner and Italy’s Marta Cammilletti won individual
            men’s and women’s gold medals at the International Satellite Foil Tournament
            in Tashkent, Uzbekistan, which took place on September 25 – 26.</strong></p>
        <p>Forty-eight athletes from multiple countries participated, including Belarus,
          Iran, Iraq, Italy, Kazakhstan, Philippines, Turkey, USA and Uzbekistan.</p>
        <p>In individual men’s foil, Gassner won against Belarus’ Uladzislau Kurylovich,
          15-10. Bronze medals went to Akhmadillokhon Solikhojiev (UZB) and Mukhammad
          Yusuf Asranov (UZB). </p>
        <p>In individual women’s foil, Cammilletti won against the Philippines’ Maxine
          Isabel Esteban, 15-2. Bronze medals went to Madinabonu Parpieva (UZB) and
          Umida Ilyosova (UZB).</p>
        <p>The event was held in accordance with FIE rules and COVID-19 protocol.</p>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim
            .fromTo(cOf("8-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("8-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("8-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("8-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop();
          resetNumbers("8-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  USA’S GASSNER, ITALY’S CAMMILLETTI WIN TASHKENT SATELLITE FOIL TOURNAMENT TASHKENT, UZBEKISTAN 29 SEPTEMBER 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="9-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim
            .fromTo(idOf("9-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function onPageLeave() {
          pg9Anim.stop();
          resetNumbers("9-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "INTERNATIONAL SATELLITE FOIL TOURNAMENT TASHKENT, UZBEKISTAN 2 OF 2  USA’s Ethan Gassner and Italy’s Marta Cammilletti won individual men’s and women’s gold medals at the International Satellite Foil Tournament in Tashkent, Uzbekistan, which took place on September 27 – 26. Forty-eight athletes from multiple countries participated, including Belarus, Iran, Iraq, Italy, Kazakhstan, Philippines, Turkey, USA and Uzbekistan. In individual men’s foil, Gassner won against Belarus’ Uladzislau Kurylovich, 15-10. Bronze medals went to Akhmadillokhon Solikhojiev (UZB) and Mukhammad Yusuf Asranov (UZB). In individual women’s foil, Cammilletti won against the Philippines’ Maxine Isabel Esteban, 15-2. Bronze medals went to Madinabonu Parpieva (UZB) and Umida Ilyosova (UZB). The event was held in accordance with FIE rules and COVID-19 protocol. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 10-title" style="top:99px;left:485px;" src="/120/en/static/_content/10-title-1.png">
        <img class="abs halfScale 10-sub" style="top:309px;left:516px;" src="/120/en/static/_content/10-sub-1.png">
        <img class="abs halfScale 10-line" style="top:305px;left:483px;" src="/120/en/static/_content/10-line-1.png">
        <img id="10-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="korea-s-kim-greece-s-georgiadou-win-2021-orleans-sabre-grand-prix">Korea’s Kim, Greece’s Georgiadou Win 2021 Orleans Sabre Grand Prix</h2>
        <img src="/120/en/static/_content/10-mobile-1.jpg">
        <p><strong>Orleans, France<br>13 November 2021</strong></p>
        <p><strong>In the first FIE Grand Prix of the 2021-2022 competition season, Korea’s world champion Junghwan Kim and Greece’s Despina Georgiadou won men’s and women’s individual events at the Orleans Sabre Grand Prix. </strong></p>
        <p>The finals took place at the Zénith d’Orléans sports arena with a total of 170 men and 162 women participating in the overall competition. </p>
        <p>In the men’s sabre event final, Kim faced Italy’s Luca Curatoli, winning the gold medal, 15-3. Curatoli defeated Japan’s Kento Yoshida in the semifinal round, 15-10, and Kim beat his teammate and world champion Sanguk Oh, 15-13.</p>
        <p>In the women’s sabre event final, Georgiadou defeated her teammate, Theodora Gkountoura, by a single point, 15-14, to take the gold. Gkountoura beat Korea’s Jisu Yoon in the semifinal round, 15-12, and Georgiadou won against Russia’s Svetlana Sheveleva, 15-12. Notably, in the quarterfinals Yoon beat her teammate and Olympic champion Jiyeon  Kim, 15-13. </p>
        <p>Final men’s sabre ranking included Junghwan Kim (KOR, gold), Luca Curatoli (ITA, silver), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) and Enver Yildirim (TUR).</p>
        <p>Final women’s sabre ranking included Despina Georgiadou (GRE, gold), Theodora Gkountoura (GRE, silver), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) and Amalia Aime (FRA).</p>
        <p>Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the FIE video series on our YouTube channel.</p>
        <p>Click Here to relive the men’s and women’s matches of the Orleans Sabre Fencing Grand Prix.</p>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim
            .fromTo(cOf("10-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("10-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("10-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("10-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg10Anim.stop();
          resetNumbers("10-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  KOREA’S KIM, GREECE’S GEORGIADOU WIN 2021 ORLEANS SABRE GRAND PRIX ORLEANS, FRANCE 13 NOVEMBER 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="11-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim
            .fromTo(idOf("11-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg11Anim.stop();
          resetNumbers("11-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SABRE GRAND PRIX ORLEANS, FRANCE, 2 OF 3  In the first FIE Grand Prix of the 2021-2022 competition season, Korea’s world champion Junghwan Kim and Greece’s Despina Georgiadou won men’s and women’s individual events at the Orleans Sabre Grand Prix. The finals took place at the Zénith d’Orléans sports arena with a total of 170 men and 162 women participating in the overall competition. In the men’s sabre event final, Kim faced Italy’s Luca Curatoli, winning the gold medal, 15-3. Curatoli defeated Japan’s Kento Yoshida in the semifinal round, 15-10, and Kim beat his teammate and world champion Sanguk Oh, 15-13. In the women’s sabre event final, Georgiadou defeated her teammate, Theodora Gkountoura, by a single point, 15-14, to take the gold. Gkountoura beat Korea’s Jisu Yoon in the semifinal round, 15-12, and Georgiadou won against Russia’s Svetlana Sheveleva, 15-12. Notably, in the quarterfinals Yoon beat her"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions/2022/158" target="_blank">
          <div class="addContentLink" style="bottom: 460px; right: 152px; width: 122px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="bottom: 412px; right: 208px; width: 130px; height: 21px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo/videos" target="_blank">
          <div class="addContentLink" style="bottom: 342px; right: 430px; width: 99px; height: 21px;"></div>
        </a>

        <img id="12-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim
            .fromTo(idOf("12-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SABRE GRAND PRIX ORLEANS, FRANCE, 3 OF 3  teammate and Olympic champion Jiyeon Kim, 15-13. Final men’s sabre ranking included Junghwan Kim (KOR, gold), Luca Curatoli (ITA, silver), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) and Enver Yildirim (TUR).  Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the FIE video series on our YouTube channel. Click Here to relive the men’s and women’s matches of the Orleans Sabre Fencing Grand Prix. ■  Final women’s sabre ranking included Despina Georgiadou (GRE, gold), Theodora Gkountoura (GRE, silver), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) and Amalia Aime (FRA).  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:lammet@mail.ru" target="_blank">
          <div class="contentLinkNone" style="bottom: 317px; right: 113px; width: 197px; height: 24px;"></div> </a>
        <a href="https://www.lammet.ru" target="_blank">
          <div class="contentLinkNone" style="bottom: 292px; right: 177px; width: 132px; height: 24px;"></div> </a>
      `,
      "mobileHtml": `
        <a href="https://www.lammet.ru" target="_blank">
          <img src="/120/en/static/_content/13-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "From Russia with great victories and traditions. \"LM Group\"  129226 Russia, Moscow, Sel'skokhozyaystvennaya street, 26 / 5  email: lammet@mail.ru www.lammet.ru +7(926)227-06-58"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 14-title" style="top:70px;left:64px;" src="/120/en/static/_content/14-title-1.png">
        <img class="abs halfScale 14-sub" style="top:220px;left:97px;" src="/120/en/static/_content/14-sub-1.png">
        <img class="abs halfScale 14-line" style="top:218px;left:64px;" src="/120/en/static/_content/14-line-1.png">
        <img id="14-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="france-s-jacques-andre-coquin-and-team-russia-win-glaive-de-tallinn-women-s-epee-world-cup">
          France’s Jacques Andre Coquin and Team Russia Win “Glaive de Tallinn” Women’s
          Epee World Cup</h2>
        <img src="/120/en/static/_content/14-mobile-1.jpg">
        <p><strong>Tallinn, Estonia<br>19-21 November 2021</strong></p>
        <p>France’s Josephine Jacques Andre Coquin won the individual gold medal and
          Russia won the gold in the team competition at the 51st “Glaive de Tallinn”
          Women’s Epee World Cup. </p>
        <p>With 246 women’s epee fencers and 26 teams competing, it was the first senior
          women’s FIE World Cup of the 2021-2022 competition season. The event took
          place at the Kalev Sports Hall.</p>
        <p>In women’s individual epee, Jacques Andre Coquin faced her teammate,
          Marie-Florence Candassamy in the final match, winning with a 15-11 score.
          Candassamy beat Italy’s Federica Isola in the semifinal round, 15-9, and
          Jacques Andre Coquin defeated her teammate, Alexandra Louis Marie, 15-11.</p>
        <p>In women’s team epee, Russia won against Germany, 43-37. Germany beat Italy
          in the semifinal round, 32-31, and Russia defeated Korea, 45-35. Italy took
          the bronze medal against Korea, 45-33.</p>
        <p>Individual women’s epee final rankings included Josephine Jacques Andre
          Coquin (FRA, gold), Marie-Florence Candassamy (FRA, silver), Federica Isola
          (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata Knapik-Miazga
          (POL), Aliya Luty (FRA), Anna Van Brummen (USA) and Lauren Rembi (FRA).</p>
        <p>Team women’s epee final rankings included Russia (gold), Germany (silver),
          Italy (bronze), Korea, Estonia, Switzerland, France and Poland.</p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the FIE
          video series on the YouTube FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim
            .fromTo(cOf("14-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("14-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("14-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("14-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg14Anim.stop();
          resetNumbers("14-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  FRANCE’S JACQUES ANDRE COQUIN AND TEAM RUSSIA WIN “GLAIVE DE TALLINN” WOMEN’S EPEE WORLD CUP TALLINN, ESTONIA 19-21 NOVEMBER 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="15-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim
            .fromTo(idOf("15-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg15Anim.stop();
          resetNumbers("15-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 2 OF 3  France’s Josephine Jacques Andre Coquin won the individual gold medal and Russia won the gold in the team competition at the 51st “Glaive de Tallinn” Women’s Epee World Cup. With 246 women’s epee fencers and 26 teams competing, it was the first senior women’s FIE World Cup of the 2021-2022 competition season. The event took place at the Kalev Sports Hall.  In women’s individual epee, Jacques Andre Coquin faced her teammate, MarieFlorence Candassamy in the final match, winning with a 15-11 score. Candassamy beat Italy’s Federica Isola in the semifinal round, 15-9, and Jacques Andre Coquin defeated her teammate, Alexandra Louis Marie, 15-11. In women’s team epee, Russia won against Germany, 43-37. Germany beat Italy in the semifinal round, 32-31, and Russia defeated"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 319px; right: 233px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 272px; right: 277px; width: 136px; height: 20px;"></div>
        </a>

        <img id="16-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim
            .fromTo(idOf("16-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 3 OF 3  Korea, 45-35. Italy took the bronze medal against Korea, 45-33. Individual women’s epee final rankings included Josephine Jacques Andre Coquin (FRA, gold), Marie-Florence Candassamy (FRA, silver), Federica Isola (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata KnapikMiazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) and Lauren Rembi (FRA). Team women’s epee final rankings included Russia (gold), Germany (silver), Italy (bronze), Korea, Estonia, Switzerland, France and Poland. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the FIE video series on the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 17-title" style="top:92px;left:64px;" src="/120/en/static/_content/17-title-1.png">
        <img class="abs halfScale 17-sub" style="top:206px;left:97px;" src="/120/en/static/_content/17-sub-1.png">
        <img class="abs halfScale 17-line" style="top:204px;left:64px;" src="/120/en/static/_content/17-line-1.png">
        <img id="17-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="venezuela-s-limardo-gascon-team-russia-win-bern-men-s-epee-world-cup">
          Venezuela’s Limardo Gascon, Team Russia Win Bern Men&#39;s Epee World Cup</h2>
        <img src="/120/en/static/_content/17-mobile-1.jpg">
        <p>​​<strong>Bern, Switzerland<br>19-​​21 November 2021</strong></p>
        <p><strong>Venezuela’s Olympic champion Ruben Limardo Gascon won the individual
            gold medal and Russia won the gold in the team competition at the Bern
            Men&#39;s Epee World Cup. </strong></p>
        <p>With 265 epee fencers and 33 teams competing, it was the first senior men’s
          FIE World Cup of the 2021-2022 competition season. The event took place at
          Bern’s Sporthalle Wankdorf.</p>
        <p>In men’s individual epee, Limardo Gascon faced France’s Alexandre Bardenet in
          the final match, winning with a 15-7 score. Bardenet defeated his teammate and
          Olympic gold medallist Romain Cannone in the semifinal round, 15-9, and
          Limardo Gascon beat Italy’s Andrea Santarelli by a single touch, 10-9.
          Bardenet also won against teammate and world champion Yannick Borel in the
          quarterfinals, 15-9.</p>
        <p>In men’s team epee, Russia won by a single point against Spain, 45-44. Spain
          beat Hungary in the semifinal round, 45-42, and Russia defeated Japan, 45-34.
          Japan took the bronze medal against Hungary, 45-34.</p>
        <p>Individual men’s epee final rankings included Ruben Limardo Gascon (VEN,
          gold), Alexandre Bardenet (FRA, silver), Romain Cannone (FRA, bronze), Andrea
          Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA)
          and Georgiy Bruev (RUS).</p>
        <p>Team men’s epee final rankings included Russia (gold), Spain (silver), Japan
          (bronze), Hungary, France, Ukraine, Denmark and Italy.</p>
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim
            .fromTo(cOf("17-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("17-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("17-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("17-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  VENEZUELA’S LIMARDO GASCON, TEAM RUSSIA WIN BERN MEN'S EPEE WORLD CUP BERN, SWITZERLAND 19-21 NOVEMBER 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="18-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim
            .fromTo(idOf("18-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg18Anim.stop();
          resetNumbers("18-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MEN'S EPEE WORLD CUP BERN, SWITZERLAND 2 OF 2  Venezuela’s Olympic champion Ruben Limardo Gascon won the individual gold medal and Russia won the gold in the team competition at the Bern Men's Epee World Cup. With 265 epee fencers and 33 teams competing, it was the first senior men’s FIE World Cup of the 2021-2022 competition season. The event took place at Bern’s Sporthalle Wankdorf. In men’s individual epee, Limardo Gascon faced France’s Alexandre Bardenet in the final match,  winning with a 15-7 score. Bardenet defeated his teammate and Olympic gold medallist Romain Cannone in the semifinal round, 159, and Limardo Gascon beat Italy’s Andrea Santarelli by a single touch, 10-9. Bardenet also won against teammate and world champion Yannick Borel in the quarterfinals, 15-9. In men’s team epee, Russia won by a single point against Spain, 45-44. Spain beat Hungary in the semifinal round, 45-42, and Russia defeated Japan, 45-34. Japan took the bronze medal against Hungary, 45-34. Individual men’s epee final rankings included Ruben Limardo Gascon (VEN, gold), Alexandre Bardenet (FRA, silver), Romain Cannone (FRA, bronze), Andrea Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) and Georgiy Bruev (RUS). Team men’s epee final rankings included Russia (gold), Spain (silver), Japan (bronze), Hungary, France, Ukraine, Denmark and Italy. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/en/static/_content/19-mobile-1.jpg">
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "© Augusto Bizzi  TOGETHER WE STAND."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 20-title" style="top:64px;left:487px;" src="/120/en/static/_content/20-title-1.png">
        <img class="abs halfScale 20-sub" style="top:217px;left:519px;" src="/120/en/static/_content/20-sub-1.png">
        <img class="abs halfScale 20-line" style="top:220px;left:487px;" src="/120/en/static/_content/20-line-1.png">
        <img id="20-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="italy-s-alice-volpi-and-team-italy-win-gold-at-st-maur-women-s-foil-world-cup">
          Italy’s Alice Volpi and Team Italy Win Gold at St. Maur Women’s Foil World Cup
        </h2>
        <img src="/120/en/static/_content/20-mobile-1.jpg">
        <p><strong>Saint-Maur-des-Fossés, France<br>10-12 De​​cember 2021</strong></p>
        <p><strong>Italy’s world champion Alice Volpi won the individual gold medal and
            Italy took the gold in the team competition at the St. Maur Women’s Foil
            World Cup.</strong></p>
        <p>The event took place at the Sport Centre Pierre Brossolette, with 182 women’s
          foil fencers and 20 teams competing.</p>
        <p>Volpi faced U.S. Olympic champion Lee Kiefer in the gold-medal match of
          individual women’s foil, winning by a single touch, 15-14. Kiefer beat her
          teammate, Jacqueline Dubrovich, in the semifinal round, 15-4, and Volpi also
          defeated her teammate, Francesca Palumbo, 15-12.</p>
        <p>In women’s team foil, Italy scored gold over Japan in the final round,
          winning with a 43-40 score. Japan beat Russia in the semifinals, 31-26, and
          Italy won against Canada, 45-37. The bronze medal went to Russia over Canada,
          44-39.</p>
        <p>Individual women’s foil rankings included Alice Volpi (ITA, gold), Lee Kiefer
          (USA, silver), Jacqueline Dubrovich (USA, bronze), Francesca Palumbo (ITA,
          bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS)
          and Kiyeun Kim (KOR).</p>
        <p>Women’s team foil rankings included Italy (gold), Japan (silver), Russia
          (bronze), Canada, Poland, China, USA and Hong Kong, China.</p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the YouTube
          FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim
            .fromTo(cOf("20-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("20-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("20-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("20-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg20Anim.stop();
          resetNumbers("20-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  ITALY’S ALICE VOLPI AND TEAM ITALY WIN GOLD AT ST. MAUR WOMEN’S FOIL WORLD CUP SAINT-MAUR-DES-FOSSÉS, FRANCE 10-12 DECEMBER 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 248px; right: 233px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 201px; right: 170px; width: 173px; height: 20px;"></div>
        </a>

        <img id="21-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim
            .fromTo(idOf("21-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg21Anim.stop();
          resetNumbers("21-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN'S FOIL WORLD CUP SAINT-MAUR-DESFOSSÉS, FRANCE 2 OF 2  Italy’s world champion Alice Volpi won the individual gold medal and Italy took the gold in the team competition at the St. Maur Women’s Foil World Cup. The event took place at the Sport Centre Pierre Brossolette, with 182 women’s foil fencers and 20 teams competing. Volpi faced U.S. Olympic champion Lee Kiefer in the gold-medal match of individual women’s foil, winning by a single touch, 15-14. Kiefer beat her teammate, Jacqueline Dubrovich, in the semifinal round, 15-4, and Volpi also defeated her teammate, Francesca Palumbo, 15-12. In women’s team foil, Italy scored gold over Japan in the final round, winning with a 4340 score. Japan beat Russia in the semifinals, 31-26, and Italy won against Canada, 45-37. The bronze medal went to Russia over Canada, 44-39.  Palumbo (ITA, bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) and Kiyeun Kim (KOR). Women’s team foil rankings included Italy (gold), Japan (silver), Russia (bronze), Canada, Poland, China, USA and Hong Kong, China. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  Individual women’s foil rankings included Alice Volpi (ITA, gold), Lee Kiefer (USA, silver), Jacqueline Dubrovich (USA, bronze), Francesca  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 22-title" style="top:85px;left:363px;" src="/120/en/static/_content/22-title-1.png">
        <img class="abs halfScale 22-sub" style="top:285px;left:396px;" src="/120/en/static/_content/22-sub-1.png">
        <img class="abs halfScale 22-line" style="top:282px;left:363px;" src="/120/en/static/_content/22-line-1.png">
        <img id="22-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="hong-kong-s-cheung-team-italy-take-gold-in-challenge-international-de-paris-men-s-foil-world-cup">
          Hong Kong’s Cheung, Team Italy take Gold in Challenge International de Paris
          Men’s Foil World Cup</h2>
        <img src="/120/en/static/_content/22-mobile-1.jpg">
        <p><strong>Paris, France<br>14-16 January 2022</strong></p>
        <p><strong>Hong Kong’s Olympic champion Ka Long Cheung won the individual gold
            medal and Italy took the gold in the team competition at the Challenge
            International (CIP) de Paris Men’s Foil World Cup.</strong></p>
        <p>The event, which took place at the Stade Pierre de Coubertin, included 210
          fencers and 26 teams participating.</p>
        <p>Cheung fenced Italy’s Edoardo Luperi in the final round of individual men’s
          foil, winning the gold with a score of 15-12. Luperi defeated USA’s Chase
          Emmer in the semifinal round, 15-13, while Cheung beat Italy’s world champion
          Alessio Foconi, 15-4. Cheung also won against French world champion Enzo
          Lefort in the quarterfinals, 15-9, and in the same round Emmer beat Italian
          Olympic champion Daniele Garozzo, 15-5.</p>
        <p>Italy took the gold in men’s team foil, defeating France in the final match,
          45-20. France beat Russia in the semifinal round, 45-39, while Italy won
          against USA, 45-38. USA took the bronze medal against Russia, 45-31.</p>
        <p>Final ranking in individual men’s foil included Ka Long Cheung (HKG, gold),
          Edoardo Luperi (ITA, silver), Chase Emmer (USA, bronze), Alessio Foconi (ITA,
          bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA)
          and Alexandre Sido (FRA).</p>
        <p>Final ranking in team men’s foil included Italy (gold), France (silver), USA
          (bronze), Russia, Japan, Egypt, Korea and Hong Kong China.</p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the YouTube
          FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim
            .fromTo(cOf("22-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("22-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("22-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("22-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  HONG KONG’S CHEUNG, TEAM ITALY TAKE GOLD IN CHALLENGE INTERNATIONAL DE PARIS MEN’S FOIL WORLD CUP PARIS, FRANCE 14-16 JANUARY 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 201px; right: 233px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 154px; right: 170px; width: 245px; height: 20px;"></div>
        </a>

        <img id="23-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim
            .fromTo(idOf("23-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MEN'S FOIL WORLD CUP PARIS, FRANCE 2 OF 2  Hong Kong’s Olympic champion Ka Long Cheung won the individual gold medal and Italy took the gold in the team competition at the Challenge International (CIP) de Paris Men’s Foil World Cup. The event, which took place at the Stade Pierre de Coubertin, included 210 fencers and 26 teams participating. Cheung fenced Italy’s Edoardo Luperi in the final round of individual men’s foil, winning the gold with a score of 15-12. Luperi defeated USA’s Chase Emmer in the semifinal round, 1513, while Cheung beat Italy’s world champion Alessio Foconi, 15-4. Cheung also won against French world champion Enzo Lefort in the quarterfinals, 15-9, and in the same round Emmer beat Italian Olympic champion Daniele Garozzo, 15-5. Italy took the gold in men’s team foil, defeating France in the final match, 45-20. France beat Russia in the semifinal round, 45-39, while Italy won against USA, 45-38. USA took the bronze medal against Russia, 45-31.  Final ranking in individual men’s foil included Ka Long Cheung (HKG, gold), Edoardo Luperi (ITA, silver), Chase Emmer (USA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) and Alexandre Sido (FRA). Final ranking in team men’s foil included Italy (gold), France (silver), USA (bronze), Russia, Japan, Egypt, Korea and Hong Kong China. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <div class="contentLinkNone" style="  bottom: 173px; right: 981px; width: 177px; height: 25px; }"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <img src="/120/en/static/_content/pg24.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Foils, epees, sabers  BF… the Best for Fencing SAS BLAISE FRERES ZI du Bec - Rue Antoine Lavoisier 42700 - LE CHAMBON-FEUGEROLLES – FRANCE https://www.blaise-freres.fr"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 25-title" style="top:87px;left:484px;" src="/120/en/static/_content/25-title-1.png">
        <img class="abs halfScale 25-sub" style="top:243px;left:770px;" src="/120/en/static/_content/25-sub-1.png">
        <img class="abs halfScale 25-line" style="top:241px;left:738px;" src="/120/en/static/_content/25-line-1.png">
        <img id="25-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="italy-s-volpi-team-usa-win-gold-at-poznan-women-s-foil-world-cup">
          Italy’s Volpi, Team USA win gold at Poznan Women’s Foil World Cup</h2>
        <p><strong>Poznan, Poland<br>14-16 January 2022</strong></p>
        <img src="/120/en/static/_content/25-mobile-1.jpg">
        <p><strong>Italy’s world champion Alice Volpi took the individual gold medal and
            Team USA won the team gold at the Adam Mickiewicz University Women’s Foil
            World Cup in Poznan, Poland.</strong></p>
        <p>The event took place at the UAM Sport Center, with 180 fencers and 20 teams
          competing.</p>
        <p>In the final round of individual women’s foil, Volpi faced Canada’s Eleanor
          Harvey, winning the gold with a 15-10 score. In the semifinal round, Harvey
          beat China’s Qingyuan Chen, 15-7, and Volpi defeated teammate Martina
          Favaretto, 15-11.</p>
        <p>In women’s team foil, USA defeated Japan in the final match, winning the gold
          with a 45-23 score. Japan won against Poland in the semifinals, 27-25, and USA
          beat Russia, 45-39. Poland took the bronze medal over Russia, 44-42.</p>
        <p>Individual women’s foil rankings included Alice Volpi (ITA, gold), Eleanor
          Harvey (CAN, silver), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN,
          bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova
          (RUS) and Elena Petrova (RUS).</p>
        <p>Women’s team foil rankings included USA (gold), Japan (silver), Poland
          (bronze), Russia, Italy, China, France and Canada.</p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the YouTube
          FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim
            .fromTo(cOf("25-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("25-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("25-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("25-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg25Anim.stop();
          resetNumbers("25-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  ITALY’S VOLPI, TEAM USA WIN GOLD AT POZNAN WOMEN’S FOIL WORLD CUP POZNAN, POLAND 14-16 JANUARY 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 201px; right: 233px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 154px; right: 170px; width: 245px; height: 20px;"></div>
        </a>

        <img id="26-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim
            .fromTo(idOf("26-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers("26-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN'S FOIL WORLD CUP POZNAN, POLAND 2 OF 2  Italy’s world champion Alice Volpi took the individual gold medal and Team USA won the team gold at the Adam Mickiewicz University Women’s Foil World Cup in Poznan, Poland. The event took place at the UAM Sport Center, with 180 fencers and 20 teams competing. In the final round of individual women’s foil, Volpi faced Canada’s Eleanor Harvey, winning the gold with a 15-10 score. In the semifinal round, Harvey beat China’s Qingyuan Chen,  15-7, and Volpi defeated teammate Martina Favaretto, 15-11. In women’s team foil, USA defeated Japan in the final match, winning the gold with a 45-23 score. Japan won against Poland in the semifinals, 27-27, and USA beat Russia, 45-39. Poland took the bronze medal over Russia, 44-42. Individual women’s foil rankings included Alice Volpi (ITA, gold), Eleanor Harvey (CAN, silver), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN, bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) and Elena Petrova (RUS). Women’s team foil rankings included USA (gold), Japan (silver), Poland (bronze), Russia, Italy, China, France and Canada. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 27-title" style="top:64px;left:454px;" src="/120/en/static/_content/27-title-1.png">
        <img class="abs halfScale 27-sub" style="top:265px;left:487px;" src="/120/en/static/_content/27-sub-1.png">
        <img class="abs halfScale 27-line" style="top:262px;left:454px;" src="/120/en/static/_content/27-line-1.png">
        <img id="27-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <p><strong>Tbilisi, Georgia<br>14-18 January 2022</strong></p>
        <h2
          id="georgia-s-bazadze-france-s-queroli-teams-korea-and-france-win-gold-at-tbilisi-sabre-world-cup">
          Georgia’s Bazadze, France’s Queroli, Teams Korea and France Win Gold at
          Tbilisi Sabre World Cup</h2>
        <img src="/120/en/static/_content/27-mobile-1.jpg">
        <p><strong>Georgia’s Sandro Bazadze and France’s Caroline Queroli took
            individual gold medals, with Korea and France winning men’s and women’s team
            competitions at the Tbilisi Sabre World Cup. </strong></p>
        <p>The event, which took place at the Olympic Palace, included 188 men and 154
          women competing as well as 24 men’s and 25 women’s teams. </p>
        <p>Bazadze faced Russia’s Kamil Ibragimov in the final match of individual men’s
          sabre, winning with a 15-8 score. Ibragimov beat Korean world champion
          Junghwan Kim in the semifinal round, 15-12, while Bazadze won against France’s
          Bolade Apithy, 15-10. Apithy defeated Korean world champion Sanguk Oh in the
          quarterfinals, 15-8, and Kim beat Hungarian world champion Andras Szatmari in
          the same round, 15-12.</p>
        <p>Queroli won against Greece’s Theodora Gkountoura in the final match of
          individual women’s sabre, 15-12. Gkountoura beat Russia’s Olympic champion
          Yana Egorian in the semifinals, 15-14, while Queroli defeated Italy’s Rossella
          Gregorio, 15-14.</p>
        <p>In men’s team sabre, Korea won against Germany in the final match, 45-38.
          Germany defeated Italy in the semifinal round, 45-43, while Korea beat Russia,
          45-44. The bronze medal went to Russia after winning against Italy, 45-40.</p>
        <p>In women’s team sabre, France took the gold medal, winning against Korea in
          the final, 45-35. France beat Spain in the semifinal round, 45-34, while Korea
          defeated Russia, 45-39. The bronze medal went to Russia over Spain, 45-43.</p>
        <p>Final rankings in men’s individual sabre included Sandro Bazadze (GEO, gold),
          Kamil Ibragimov (RUS, silver), Bolade Apithy (FRA, bronze), Junghwan Kim (KOR,
          bronze), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) and
          Giovanni Repetti (ITA).</p>
        <p>Final rankings in women’s individual sabre included Caroline Queroli (FRA,
          gold), Theodora Gkountoura (GRE, silver), Yana Egorian (RUS, bronze), Rossella
          Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS),
          Sara Balzer (FRA) and Seri Ozaki (JPN).</p>
        <p>Final rankings in men’s team sabre included Korea (gold), Germany (silver)
          Russia (bronze), Italy, Iran, Egypt, Hungary and France. </p>
        <p>Final rankings in women’s team sabre included France (gold), Korea (silver),
          Russia (bronze), Spain, Italy, Bulgaria, Hungary and Poland. </p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the YouTube
          FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim
            .fromTo(cOf("27-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("27-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("27-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("27-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg27Anim.stop();
          resetNumbers("27-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  GEORGIA’S BAZADZE, FRANCE’S QUEROLI, TEAMS KOREA AND FRANCE WIN GOLD AT TBILISI SABRE WORLD CUP TBILISI, GEORGIA 14-18 JANUARY 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="28-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim
            .fromTo(idOf("28-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg28Anim.stop();
          resetNumbers("28-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SABRE WORLD CUP TBILISI, GEORGIA 2 OF 3  Georgia’s Sandro Bazadze and France’s Caroline Queroli took individual gold medals, with Korea and France winning men’s and women’s team competitions at the Tbilisi Sabre World Cup. The event, which took place at the Olympic Palace, included 188 men and 154 women competing as well as 24 men’s and 27 women’s teams. Bazadze faced Russia’s Kamil Ibragimov in the final match of individual men’s sabre, winning with a 15-8 score. Ibragimov beat Korean world champion Junghwan Kim in the semifinal round, 15-12, while Bazadze won against France’s Bolade Apithy, 15-10. Apithy defeated Korean world champion Sanguk Oh in the quarterfinals, 15-8, and Kim beat Hungarian world champion Andras Szatmari in the same round, 15-12. Queroli won against Greece’s Theodora Gkountoura in the final match of individual women’s sabre, 15-12. Gkountoura beat Russia’s Olympic champion Yana Egorian in  the semifinals, 15-14, while Queroli defeated Italy’s Rossella Gregorio, 15-14. In men’s team sabre, Korea won against Germany in the final match, 45-38. Germany defeated Italy in the semifinal round, 45-43, while Korea beat Russia, 45-44. The bronze medal went to Russia after winning against Italy, 45-40."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 296px; right: 233px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 247px; right: 168px; width: 174px; height: 20px;"></div>
        </a>

        <img id="29-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim
            .fromTo(idOf("29-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg29Anim.stop();
          resetNumbers("29-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SABRE WORLD CUP TBILISI, GEORGIA 3 OF 3  In women’s team sabre, France took the gold medal, winning against Korea in the final, 45-35. France beat Spain in the semifinal round, 45-34, while Korea defeated Russia, 45-39. The bronze medal went to Russia over Spain, 45-43. Final rankings in men’s individual sabre included Sandro Bazadze (GEO, gold), Kamil Ibragimov (RUS, silver), Bolade Apithy (FRA, bronze), Junghwan Kim (KOR, bronze), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) and Giovanni Repetti (ITA). Final rankings in women’s individual sabre included Caroline Queroli (FRA, gold), Theodora Gkountoura (GRE, silver), Yana Egorian (RUS, bronze), Rossella Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) and Seri Ozaki (JPN).  Final rankings in men’s team sabre included Korea (gold), Germany (silver) Russia (bronze), Italy, Iran, Egypt, Hungary and France. Final rankings in women’s team sabre included France (gold), Korea (silver), Russia (bronze), Spain, Italy, Bulgaria, Hungary and Poland. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1095px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://www.instagram.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1074px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 966px; width: 104px; height: 18px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <img src="/120/en/static/_content/30-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "uhlmann-fencing.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 31-title" style="top:81px;left:64px;" src="/120/en/static/_content/31-title-1.png">
        <img class="abs halfScale 31-sub" style="top:188px;left:97px;" src="/120/en/static/_content/31-sub-1.png">
        <img class="abs halfScale 31-line" style="top:185px;left:64px;" src="/120/en/static/_content/31-line-1.png">
        <img id="31-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="azerbaijans-bashta-team-france-win-gold-at-women-s-sabre-world-cup">
          Azerbaijans Bashta, Team France win gold at Women’s Sabre World Cup</h2>
        <img src="/120/en/static/_content/31-mobile-1.jpg">
        <p><strong>Plovdiv, Bulgaria<br>28-30 January 2022</strong></p>
        <p><strong>Azerbaijan’s Anna Bashta and Team France took gold medals at the
            Women’s Sabre World Cup in Plovdiv, Bulgaria.</strong></p>
        <p>The event, which took place at the Complex SILA, included 136 women’s sabre
          fencers and 20 teams.</p>
        <p>Bashta faced France’s Manon Apithy-Brunet in the final round of the
          individual event, winning with at 15-10 score. Apithy-Brunet beat her
          teammate, Malina Vongsavady, in the semifinals, 15-9, and Bashta defeated
          Italy’s Rossella Gregorio, 15-13.</p>
        <p>In the women’s team sabre competition, France defeated Azerbaijan in the
          final match, 45-39. Azerbaijan won against Bulgaria in the semifinals, 45-32,
          and France beat Italy, 45-23. Italy went on to take the bronze medal against
          Bulgaria, 45-29.</p>
        <p>Individual women’s sabre rankings included Anna Bashta (AZE, gold), Manon
          Apithy-Brunet (FRA, silver), Rossella Gregorio (ITA, bronze), Malina
          Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga
          Nikitina (RUS) and Svetlana Sheveleva (RUS).</p>
        <p>Rankings for women’s team sabre included France (gold), Azerbaijan (silver),
          Italy (bronze), Bulgaria, Hungary, Spain, Turkey and Germany.</p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the YouTube
          FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim
            .fromTo(cOf("31-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("31-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("31-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("31-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg31Anim.stop();
          resetNumbers("31-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  AZERBAIJANS BASHTA, TEAM FRANCE WIN GOLD AT WOMEN’S SABRE WORLD CUP PLOVDIV, BULGARIA 28-30 JANUARY 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 201px; right: 233px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 154px; right: 170px; width: 245px; height: 20px;"></div>
        </a>

        <img id="32-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim
            .fromTo(idOf("32-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN'S SABRE WORLD CUP PLOVDIV, BULGARIA 2 OF 2  Azerbaijan’s Anna Bashta and Team France took gold medals at the Women’s Sabre World Cup in Plovdiv, Bulgaria. The event, which took place at the Complex SILA, included 136 women’s sabre fencers and 20 teams. Bashta faced France’s Manon Apithy-Brunet in the final round of the individual event, winning with at 15-10 score. Apithy-Brunet beat her teammate, Malina Vongsavady, in the semifinals, 15-9, and Bashta defeated Italy’s Rossella Gregorio, 15-13. In the women’s team sabre competition, France defeated Azerbaijan in the final match, 45-39. Azerbaijan won against Bulgaria in the semifinals, 45-32, and France beat Italy, 45-23.  Italy went on to take the bronze medal against Bulgaria, 45-29. Individual women’s sabre rankings included Anna Bashta (AZE, gold), Manon ApithyBrunet (FRA, silver), Rossella Gregorio (ITA, bronze), Malina Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) and Svetlana Sheveleva (RUS). Rankings for women’s team sabre included France (gold), Azerbaijan (silver), Italy (bronze), Bulgaria, Hungary, Spain, Turkey and Germany. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 33-title" style="top:108px;left:395px;" src="/120/en/static/_content/33-title-1.png">
        <img class="abs halfScale 33-sub" style="top:264px;left:426px;" src="/120/en/static/_content/33-sub-1.png">
        <img class="abs halfScale 33-line" style="top:263px;left:394px;" src="/120/en/static/_content/33-line-1.png">
        <img id="33-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="france-s-borel-estonia-s-lehis-win-qatar-epee-grand-prix">France’s
          Borel, Estonia’s Lehis win Qatar Epee Grand Prix</h2>
        <img src="/120/en/static/_content/33-mobile-1.jpg">
        <p><strong>Doha, Qatar<br>28-30 January 2022</strong></p>
        <p><strong>France’s world champion Yannick Borel and Estonia’s Katrina Lehis
            took individual gold medals at the 2022 Qatar Fencing Epee Grand Prix in
            Doha.</strong></p>
        <p>The event, which took place at the Aspire Zone/Aspire Dome sports complex,
          included 161 men and 120 women competing.</p>
        <p>In the final match of individual men’s epee, Borel faced teammate Aymerick
          Gally, winning with a 15-10 score. Gally beat Italy’s Federico Vismara in the
          semifinals, 15-6, and Borel defeated Italy’s Davide Di Veroli, 15-9. Of note,
          French Olympic champion Romain Cannone lost in the quarterfinals to Borel,
          15-5, and Hungarian world champion Gergely Siklosi lost against Di Veroli in
          the round of 16, 15-12.</p>
        <p>In women’s individual epee, Lehis won in the final round against teammate
          Nelli Differt, 15-11. Differt beat another teammate, Erika Kirpu, in the
          semifinal round, 12-11, and Lehis won against France’s Marie-Florence
          Candassamy, 15-14. Of note, Candassamy beat Ukrainian Olympic champion Yana
          Shemyakina in the quarterfinals, 15-9.</p>
        <p>Final ranking in men’s epee included Yannick Borel (FRA, gold), Aymerick
          Gally (FRA, silver), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA,
          bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA)
          and Volodymyr Stankevych (UKR). </p>
        <p>Final ranking in women’s epee included Katrina Lehis (EST, gold), Nelli
          Differt (EST, silver), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu
          (EST, bronze), Renata Knapik- Miazga (POL), Irina Embrich (EST), Anna Kun
          (HUN) and Yana Shemyakina (UKR).</p>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim
            .fromTo(cOf("33-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("33-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("33-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("33-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  FRANCE’S BOREL, ESTONIA’S LEHIS WIN QATAR EPEE GRAND PRIX DOHA, QATAR 28-30 JANUARY 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="34-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim
            .fromTo(idOf("34-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("34-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "EPEE GRAND PRIX DOHA, QATAR 2 OF 2  France’s world champion Yannick Borel and Estonia’s Katrina Lehis took individual gold medals at the 2022 Qatar Fencing Epee Grand Prix in Doha. The event, which took place at the Aspire Zone/Aspire Dome sports complex, included 161 men and 120 women competing. In the final match of individual men’s epee, Borel faced teammate Aymerick Gally, winning with a 15-10 score. Gally beat Italy’s Federico Vismara in the semifinals, 15-6, and Borel defeated Italy’s Davide Di Veroli, 15-9. Of note, French Olympic champion Romain Cannone lost in the quarterfinals to Borel, 15-5, and Hungarian world champion Gergely Siklosi lost against Di Veroli in the round of 16, 15-12. In women’s individual epee, Lehis won in the final round against teammate Nelli Differt, 1511. Differt beat another teammate, Erika Kirpu, in the semifinal round, 12-11, and Lehis won against France’s Marie-Florence Candassamy,  15-14. Of note, Candassamy beat Ukrainian Olympic champion Yana Shemyakina in the quarterfinals, 15-9. Final ranking in men’s epee included Yannick Borel (FRA, gold), Aymerick Gally (FRA, silver), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA, bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) and Volodymyr Stankevych (UKR). Final ranking in women’s epee included Katrina Lehis (EST, gold), Nelli Differt (EST, silver), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu (EST, bronze), Renata KnapikMiazga (POL), Irina Embrich (EST), Anna Kun (HUN) and Yana Shemyakina (UKR). ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 35-title" style="top:103px;left:381px;" src="/120/en/static/_content/35-title-1.png">
        <img class="abs halfScale 35-sub" style="top:207px;left:410px;" src="/120/en/static/_content/35-sub-1.png">
        <img class="abs halfScale 35-line" style="top:205px;left:378px;" src="/120/en/static/_content/35-line-1.png">
        <img id="35-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="men-s-and-women-s-epee-grand-prix-in-budapest">Men’s and Women’s Epee
          Grand Prix in Budapest</h2>
        <img src="/120/en/static/_content/35-mobile-1.jpg">
        <p><strong>Budapest, Hungary<br>4-6 March 2022</strong></p>
        <p><strong>Venezuela’s Olympic champion Ruben Limardo-Gascon won the individual
            men’s gold and Italy’s Alberta Santuccio won the individual women’s gold at
            the Budapest Westend Epee Grand Prix.</strong></p>
        <p>The competition took place at the BOK Hall (former SYMA Hall) and included
          271 men’s and 210 women’s epeeists participating. The Grand Prix was dedicated
          to the memories of József Sákovics for the men’s event and Győző Kulcsár for
          the women’s event.</p>
        <p>Limardo Gascon won the gold medal in men’s epee against Hungary’s David Nagy,
          13-5. Nagy beat Finland’s Niko Vuorinen in the semifinal match, 12-11, while
          Limardo Gascon won against Italy’s Gabriele Cimini, 13-9. </p>
        <p>Santuccio won the gold medal in women’s epee against Hungary’s Anna Kun,
          15-7. Kun beat Estonia’s Katrina Lehis in the semifinal match, 14-11, while
          Santuccio won against Korea’s Injeong Choi, 12-11. Of note, Lehis defeated
          Italy’s two-time world champion Rossella Fiamingo in the quarterfinals, 12-11.
        </p>
        <p>Final rankings in men’s epee included Ruben Limardo Gascon (VEN, gold), David
          Nagy (HUN, silver), Gabriele Cimini (ITA, bronze), Niko Vuorinen (FIN,
          bronze), Andrea Santarelli (ITA), Kazuyasu Minobe (JPN), Ruslan Kurbanov (KAZ)
          and Mate Tamas Koch (HUN).</p>
        <p>Final rankings in women’s epee included Alberta Santuccio (ITA, gold), Anna
          Kun (HUN, silver), Injeong Choi (KOR, bronze), Katrina Lehis (EST, bronze),
          Rossella Fiamingo (ITA), Katharine Holmes (USA), Anne Cebula (USA) and
          Kristina Kuusk (EST).</p>
        <p>Complete and official results for the event may be found here on the FIE web
          site. For more exciting world fencing news and features, check out the YouTube
          FIE Fencing Channel.</p>
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim
            .fromTo(cOf("35-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("35-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("35-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("35-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg35Anim.stop();
          resetNumbers("35-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  MEN'S AND WOMEN'S EPEE GRAND PRIX IN BUDAPEST BUDAPEST, HUNGARY 4–6 MARCH 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="36-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim
            .fromTo(idOf("36-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg36Anim.stop();
          resetNumbers("36-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "EPEE GRAND PRIX BUDAPEST, HUNGARY 2 OF 3  Venezuela’s Olympic champion Ruben Limardo-Gascon won the individual men’s gold and Italy’s Alberta Santuccio won the individual women’s gold at the Budapest Westend Epee Grand Prix. The competition took place at the BOK Hall (former SYMA Hall) and included 271 men’s and 210 women’s epeeists participating. The Grand Prix was dedicated to the memories of József Sákovics for the men’s event and Győző Kulcsár for the women’s event. Limardo Gascon won the gold medal in men’s epee against Hungary’s David Nagy, 13-5.  Nagy beat Finland’s Niko Vuorinen in the semifinal match, 12-11, while Limardo Gascon won against Italy’s Gabriele Cimini, 13-9. Santuccio won the gold medal in women’s epee against Hungary’s Anna Kun, 15-7. Kun beat Estonia’s Katrina Lehis in the semifinal match, 14-11, while Santuccio won against Korea’s Injeong Choi, 12-11. Of note, Lehis defeated Italy’s two-time world champion Rossella Fiamingo in the quarterfinals, 12-11. Final rankings in men’s epee included Ruben Limardo Gascon (VEN, gold), David Nagy (HUN, silver), Gabriele Cimini (ITA, bronze), Niko"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 624px; right: 156px; width: 114px; height: 20px; "></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 577px; right: 152px; width: 111px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 554px; right: 388px; width: 139px; height: 20px;"></div>
        </a>

        <img id="37-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim
            .fromTo(idOf("37-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg37Anim.stop();
          resetNumbers("37-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "EPEE GRAND PRIX BUDAPEST, HUNGARY 3 OF 3  Vuorinen (FIN, bronze), Andrea Santarelli (ITA), Kazuyasu Minobe (JPN), Ruslan Kurbanov (KAZ) and Mate Tamas Koch (HUN). Final rankings in women’s epee included Alberta Santuccio (ITA, gold), Anna Kun (HUN, silver), Injeong Choi (KOR, bronze), Katrina Lehis (EST, bronze), Rossella Fiamingo (ITA),  Katharine Holmes (USA), Anne Cebula (USA) and Kristina Kuusk (EST). Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/en/static/_content/38-mobile-1.jpg">
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 39-title" style="top:75px;left:64px;" src="/120/en/static/_content/39-title-1.png">
        <img class="abs halfScale 39-sub" style="top:188px;left:694px;" src="/120/en/static/_content/39-sub-1.png">
        <img class="abs halfScale 39-line" style="top:186px;left:661px;" src="/120/en/static/_content/39-line-1.png">
        <img id="39-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="a-grand-and-successful-2022-junior-and-cadet-fencing-world-championships-in-dubai">
          A grand and successful 2022 Junior and Cadet Fencing World Championships in
          Dubai</h2>
        <img src="/120/en/static/_content/39-mobile-1.jpg">
        <p><strong>Dubai, United Arab Emirates<br>2-10 April 2022</strong></p>
        <p><strong>The 2022 Junior and Cadet Fencing World Championships have been
            declared a spectacular success by FIE Interim President Emmanuel
            Katsiadakis.</strong></p>
        <p>The nine-day event, which included 18 individual and team events for junior
          and cadet men and women fencers, had the largest number of participants in its
          history, with 1357 fencers from 103 countries. It took place at Dubai’s
          impressive Hamdan Sports Complex, a world-class multi-purpose sports facility
          known for hosting a broad array of international championships and events.</p>
        <p>The following shows the countries participating in the Junior and Cadet
          Fencing World Championships, by continental regions:</p>
        <ul>
          <li>Africa 13</li>
          <li>Americas 20</li>
          <li>Asia/Oceania 32</li>
          <li>Europe 38</li>
          <li>Total 103</li>
        </ul>
        <p>The official opening ceremony for the Championships featured several local
          dignitaries attending, including H.E. Dr. Ahmad bin Abdullah Humaid Belhoul Al
          Falasi, Minister of State for Entrepreneurship and SMEs and Chairman of the
          Board of Directors of the General Sports Authority; H.E. Sheikh Salem bin
          Sultan Al Qasimi, FIE Executive Committee member, Asian Fencing Confederation
          President, Arab Fencing Federation President and UAE Fencing Federation
          President; H.E. Saeed Hareb, Secretary-General of the Dubai Sports Council;
          and H.E. Nasser Al Rahma, Vice Chairman of the Hamdan Sports Complex. The
          Championships were declared officially open by FIE Interim President Emmanuel
          Katsiadakis.</p>
        <p>Each weapon (sabre, foil, epee) had three days of competition in a row, with
          each threeday cycle including a first day of men’s and women’s individual
          junior events, followed by a day of individual cadet events and ending with a
          day of junior team events.</p>
        <p>COVID-19 protocols at the Championships were followed to ensure safety for
          all participants and attendees, including a mask mandate, social distancing as
          well as regular testing. Top rankings included the following results:</p>
        <p>SABRE</p>
        <ul>
          <li>Junior Men’s Individual Sabre (152 fencers)<ol>
              <li>Colin Heathcock (GER, gold)</li>
              <li>Pietro Torre (ITA, silver)</li>
              <li>Antonio Heathcock (GER, bronze)</li>
              <li>Heegeun Hwang (KOR, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Women’s Individual Sabre (126 fencers)<ol>
              <li>Magda Skarbonkiewicz (USA, gold)</li>
              <li>Honor Johnson (USA, silver)</li>
              <li>Zaynab Dayibekova (UZB, bronze)</li>
              <li>Sugar Katinka Battai (HUN, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Cadet Men’s Individual Sabre (95 fencers)<ol>
              <li>Zuhridden Kodirov (UZB, gold)</li>
              <li>Colin Heathcock (GER, silver)</li>
              <li>Cody Ji (USA, bronze)</li>
              <li>William Morrill (USA, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Cadet Women’s Individual Sabre (90 fencers)<ol>
              <li>Magda Skarbonkiewicz (USA, gold)</li>
              <li>Siobhan Sullivan (USA, silver)</li>
              <li>Alejandra Manga (FRA, bronze)</li>
              <li>Eunyu Kim (KOR, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Men’s Team Sabre (34 teams)<ol>
              <li>Italy (gold)</li>
              <li>Romania (silver)</li>
              <li>Egypt (bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Women’s Team Sabre (27 teams)<ol>
              <li>France (gold)</li>
              <li>Hungary (silver)</li>
              <li>Italy (bronze)</li>
            </ol>
          </li>
        </ul>
        <p>FOIL</p>
        <ul>
          <li>Junior Men’s Individual Foil (180 fencers)<ol>
              <li>Kazuki Iimura (JPN, gold)</li>
              <li>Hyeonbhin An (KOR, silver)</li>
              <li>Anas Anane (FRA, bronze)</li>
              <li>Chase T. Emmer (USA, bronze</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Women’s Individual Foil (148 fencers)<ol>
              <li>Lauren Scruggs (USA, gold)</li>
              <li>Yuzuha Takeyama (JPN, silver)</li>
              <li>Carolina Stutchbury (GBR, bronze)</li>
              <li>Kateryna Budenko (UKR, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Cadet Men’s Individual Foil (117 fencers)<ol>
              <li>Tit Nam Cheng (HKG, gold)</li>
              <li>Ruben Lindner (GER, silver)</li>
              <li>Matteo Iacomoni (ITA, bronze)</li>
              <li>Andrew Chen (USA, bronze)</li>
            </ol>
          </li>
          <li>Cadet Women’s Individual Foil (104 women)<ol>
              <li>Jessica Zi Jia Guo (CAN, gold)</li>
              <li>Carolina Stutchbury (GBR, silver)</li>
              <li>Rino Nagase (JPN, bronze)</li>
              <li>Matilde Molinari (ITA, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Men’s Team Foil (37 teams)<ol>
              <li>Italy (gold)</li>
              <li>France (silver)</li>
              <li>Hungary (bronze</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Women’s Team Foil (32 teams)<ol>
              <li>USA (gold)</li>
              <li>Italy (silver)</li>
              <li>Japan (bronze)</li>
            </ol>
          </li>
        </ul>
        <p>EPEE</p>
        <ul>
          <li>Junior Men’s Individual Epee (208 fencers)<ol>
              <li>Zsombor Keszthelyi (HUN, gold)</li>
              <li>Mohamed Yasseen (EGY, silver)</li>
              <li>James Jeal (GBR, bronze)</li>
              <li>Lino Heurlin Vazquez (FRA, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Women’s Individual Epee (160 fencers)<ol>
              <li>Hadley Husisian (USA, gold)</li>
              <li>Nicole Feygin (ISR, silver)</li>
              <li>Aleyna Erturk (TUR, bronze)</li>
              <li>Ketki Ketkar (USA, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Cadet Men’s Individual Epee (142 fencers)<ol>
              <li>Samuel Imrek (USA, gold)</li>
              <li>Alon Sarid (ISR, silver)</li>
              <li>Fabio Mastromarino (ITA, bronze)</li>
              <li>Maksym Perchuk (UKR, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Cadet Women’s Individual Epee (109 fencers)<ol>
              <li>Aleyna Erturk (TUR, gold)</li>
              <li>Anna Maksymenko (UKR, silver)</li>
              <li>Hailin Chen (HKG, bronze)</li>
              <li>Mizuki Homma (JPN, bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Men’s Team Epee (42 teams)<ol>
              <li>Egypt (gold)</li>
              <li>USA (silver)</li>
              <li>France (bronze)</li>
            </ol>
          </li>
        </ul>
        <ul>
          <li>Junior Women’s Team Epee (33 teams)<ol>
              <li>Israel (gold)</li>
              <li>Poland (silver)</li>
              <li>USA (bronze)</li>
            </ol>
          </li>
        </ul>
        <p>Tap here to see the GOLD MEDALLISTS
          [Pop-up]</p>
        <p>MEDAL TABLE</p>
        <ol>
          <li>USA - 6 Gold, 3 Silver, 6 Bronze - 15 Total</li>
          <li>ITA - 2 Gold, 2 Silver, 4 Bronze - 8 Total</li>
          <li>GER - 1 Gold, 2 Silver, 1 Bronze - 4 Total</li>
          <li>ISR - 1 Gold, 2 Silver, 0 Bronze - 3 Total</li>
          <li>FRA - 1 Gold, 1 Silver, 4 Bronze - 6 Total</li>
          <li>JPN - 1 Gold, 1 Silver, 3 Bronze - 5 Total</li>
          <li>HUN - 1 Gold, 1 Silver, 2 Bronze - 4 Total</li>
          <li>EGY - 1 Gold, 1 Silver, 1 Bronze - 3 Total</li>
          <li>TUR - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>
          <li>HKG - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>
          <li>UZB - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>
          <li>CAN - 1 Gold, 0 Silver, 0 Bronze - 1 Total</li>
          <li>UKR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>
          <li>GBR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>
          <li>KOR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>
          <li>POL - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>
          <li>ROU - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>
        </ol>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim
            .fromTo(cOf("39-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("39-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("39-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("39-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg39Anim.stop();
          resetNumbers("39-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SP ORT  A GRAND AND SUCCESSFUL 2022 JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS IN DUBAI  DUBAI, UNITED ARAB EMIRATES 2–10 APRIL 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="40-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim
            .fromTo(idOf("40-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 2 OF 5  The 2022 Junior and Cadet Fencing World Championships have been declared a spectacular success by FIE Interim President Emmanuel Katsiadakis. The nine-day event, which included 18 individual and team events for junior and cadet men and women fencers, had the largest number of participants in its history, with 1357 fencers from 103 countries. It took place at Dubai’s impressive Hamdan Sports Complex, a world-class multi-purpose sports facility known for hosting a broad array of international championships and events.  The following shows the countries participating in the Junior and Cadet Fencing World Championships, by continental regions: Africa			13 Americas			20 Asia/Oceania		 32 Europe			38 Total			103 The official opening ceremony for the Championships featured several local dignitaries attending, including H.E. Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Minister of State for Entrepreneurship and SMEs and Chairman of the Board of Directors of the"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="41-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim
            .fromTo(idOf("41-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg41Anim.stop();
          resetNumbers("41-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 3 OF 5  General Sports Authority; H.E. Sheikh Salem bin Sultan Al Qasimi, FIE Executive Committee member, Asian Fencing Confederation President, Arab Fencing Federation President and UAE Fencing Federation President; H.E. Saeed Hareb, Secretary-General of the Dubai Sports Council; and H.E. Nasser Al Rahma, Vice Chairman of the Hamdan Sports Complex. The Championships were declared officially open by FIE Interim President Emmanuel Katsiadakis. Each weapon (sabre, foil, epee) had three days of competition in a row, with each threeday cycle including a first day of men’s and women’s individual junior events, followed by a day of individual cadet events and ending with a day of junior team events. COVID-19 protocols at the Championships were followed to ensure safety for all participants and attendees, including a mask mandate, social distancing as well as regular testing.  Top rankings included the following results: SABRE • Junior Men’s Individual Sabre (152 fencers) 1. Colin Heathcock (GER, gold) 2. Pietro Torre (ITA, silver) 3. Antonio Heathcock (GER, bronze) 3. Heegeun Hwang (KOR, bronze) • Junior Women’s Individual Sabre (126 fencers) 1. Magda Skarbonkiewicz (USA, gold) 2. Honor Johnson (USA, silver) 3. Zaynab Dayibekova (UZB, bronze) 3. Sugar Katinka Battai (HUN, bronze) • Cadet Men’s Individual Sabre (95 fencers) 1. Zuhridden Kodirov (UZB, gold) 2. Colin Heathcock (GER, silver) 3. Cody Ji (USA, bronze) 3. William Morrill (USA, bronze)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>

        <img id="42-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim
            .fromTo(idOf("42-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg42Anim.stop();
          resetNumbers("42-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "FOIL • Junior Men’s Individual Foil (180 fencers) 1. Kazuki Iimura (JPN, gold) 2. Hyeonbhin An (KOR, silver) 3. Anas Anane (FRA, bronze) 3. Chase T. Emmer (USA, bronze  JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 4 OF 5  • Cadet Women’s Individual Sabre (90 fencers) 1. Magda Skarbonkiewicz (USA, gold) 2. Siobhan Sullivan (USA, silver) 3. Alejandra Manga (FRA, bronze) 3. Eunyu Kim (KOR, bronze) • Junior Men’s Team Sabre (34 teams) 1. Italy (gold) 2. Romania (silver) 3. Egypt (bronze) • Junior Women’s Team Sabre (27 teams) 1. France (gold) 2. Hungary (silver) 3. Italy (bronze)  • Junior Women’s Individual Foil (148 fencers) 1. Lauren Scruggs (USA, gold) 2. Yuzuha Takeyama (JPN, silver) 3. Carolina Stutchbury (GBR, bronze) 3. Kateryna Budenko (UKR, bronze) • Cadet Men’s Individual Foil (117 fencers) 1. Tit Nam Cheng (HKG, gold) 2. Ruben Lindner (GER, silver) 3. Matteo Iacomoni (ITA, bronze) 3. Andrew Chen (USA, bronze) • Cadet Women’s Individual Foil (104 women) 1. Jessica Zi Jia Guo (CAN, gold) 2. Carolina Stutchbury (GBR, silver) 3. Rino Nagase (JPN, bronze) 3. Matilde Molinari (ITA, bronze)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-red.png">
        </a>
          
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:655px;left:45px" onclick="showOverlay('43-popups')"
          src="/120/en/static/_content/trophy-red.png">
        
        <img id="43-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="43-popups" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" src="/120/en/static/_content/39-popup-1.png" alt="">
          <div class="contentLink" style="top: 66px; left: 1030px; width: 35px; height: 35px;" onclick="hideOverlay('43-popups');"></div>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg43Anim = new TimelineMax();
          pg43Anim
            .fromTo(idOf("43-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg43Anim.stop();
          resetNumbers("43-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 5 OF 5  • Junior Men’s Team Foil (37 teams) 1. Italy (gold) 2. France (silver) 3. Hungary (bronze • Junior Women’s Team Foil (32 teams) 1. USA (gold) 2. Italy (silver) 3. Japan (bronze) EPEE • Junior Men’s Individual Epee (208 fencers) 1. Zsombor Keszthelyi (HUN, gold) 2. Mohamed Yasseen (EGY, silver) 3. James Jeal (GBR, bronze) 3. Lino Heurlin Vazquez (FRA, bronze) • Junior Women’s Individual Epee (160 fencers) 1. Hadley Husisian (USA, gold) 2. Nicole Feygin (ISR, silver) 3. Aleyna Erturk (TUR, bronze) 3. Ketki Ketkar (USA, bronze)  Tap here to see the GOLD MEDALLISTS  • Cadet Men’s Individual Epee (142 fencers) 1. Samuel Imrek (USA, gold) 2. Alon Sarid (ISR, silver) 3. Fabio Mastromarino (ITA, bronze) 3. Maksym Perchuk (UKR, bronze) • Cadet Women’s Individual Epee (109 fencers) 1. Aleyna Erturk (TUR, gold) 2. Anna Maksymenko (UKR, silver) 3. Hailin Chen (HKG, bronze) 3. Mizuki Homma (JPN, bronze) • Junior Men’s Team Epee (42 teams) 1. Egypt (gold) 2. USA (silver) 3. France (bronze) • Junior Women’s Team Epee (33 teams) 1. Israel (gold) 2. Poland (silver) 3. USA (bronze) ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:service@blue-gauntletservice.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 277px; right: 647px; width: 175px; height: 21px;"></div>
        </a>
        <!-- <a href="mailto:service@blue-gauntletservice.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 201px; right: 697px; width: 265px; height: 21px;"></div>
        </a> -->
        <a href="https://www.blue-gauntlet.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 255px; right: 685px; width: 135px; height: 21px;"></div>
        </a>
        <!-- <a href="https://www.blue-gauntlet.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 157px; right: 751px; width: 209px; height: 38px;"></div>
        </a> -->
      `,
      "mobileHtml": `
        <a href="https://www.blue-gauntlet.com" target="_blank">
          <img src="/120/en/static/_content/44-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 45-title" style="top:58px;left:65px;" src="/120/en/static/_content/45-title-1.png">

        <img id="45-next" class="halfScale pointer" style="top:718px;right:-243px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-long-pink.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
        
        <div class="contentLink" onclick="showOverlay('45-popups')" style="bottom: 385px; right: 130px; width: 55px; height: 23px;"></div>

        <div id="45-popups" class="standardTransition contentOverlay hidden noclick">
          <img id="45-pop-1" class="halfScale 45-popup" src="/120/en/static/_content/45-popup-1.png" alt="">
          <img id="45-pop-2" class="halfScale 45-popup" src="/120/en/static/_content/45-popup-2.png" style="opacity:0" alt="">
          <div class="contentLink" style="top:721px;left:600px;width:138px;height:48px;"
            onclick="togglePage45('45-pop-1', '45-popup');"></div>
          <div class="contentLink" style="top:721px;left:738px;width:138px;height:48px;"
            onclick="togglePage45('45-pop-2', '45-popup');"></div>
          <div class="contentLink" style="top: 40px; left: 1040px; width: 35px; height: 35px;"
            onclick="hideOverlay('45-popups');"></div>
        </div>
      `,
      "mobileHtml": `
        <h2
          id="bert-m-j-van-de-flier-ned-mh-given-royal-decoration-from-the-netherlands">
          Bert M.J. van de Flier (NED, MH) Given Royal Decoration from the Netherlands
        </h2>
        <img src="/120/en/static/_content/45-mobile-1.jpg">
        <p><strong> Lausanne, Switzerland<br>6 December 2021</strong></p>
        <p><strong>The FIE has been informed that FIE Member of Honour and Member of the
            FIE Fair-Play Council Bert M. J. van der Flier (NED) received a royal
            decoration, “Officer in the Order of Oranje-Nassau”, from his Excellency
            Pieter de Gooijer, the Dutch ambassador to France. The presentation took
            place in the presence of Mr. Dominique Breton, honorary consul in Brest; Mr.
            Guy Pennec, mayor of Plourin-les-Morlaix; and Leon Pijnappel, chairman of
            the Royal Dutch Fencing Federation (KNAS).</strong></p>
        <p>The decoration exceeds knighthood, one of the higher awards that may be
          bestowed upon a civilian from the Netherlands and given to him in recognition
          of his many years of service and dedication to Dutch, European and world
          fencing. Over many years, Mr. van de Flier has had many roles and achievements
          in fencing leading to his award:</p>
        <p>Mr. van de Flier was appointed an FIE Member of Honour by the 2013 Paris
          Congress and inducted into the FIE Hall of Fame in 2014. He served as a member
          of the FIE Scale of Votes Commission, the Disciplinary Panel and has chaired
          the FIE Fair-Play Council. He has been the DT president at World Championships
          and a frequent official FIE World Cup supervisor.</p>
        <p>Since 2012, Mr. van de Flier has worked on the International Fair Play
          Committee (CIFP) and been its secretary-treasurer since 2015. His work led to
          the 2017 creation of the FIE Fair-Play Council.</p>
        <p>Royal Decoration from the Netherlands Mr. van de Flier has been a Member of
          Honour of the KNAS since 1995 and actively involved in the organisation since
          1978. He chaired its Technical Commission before becoming the KNAS
          secretary-general in 1981 and interim president in 1982. He then became the
          youngest president of the KNAS, a role he held for 12 years. After leaving the
          board in 1995, he rejoined as secretary-general in 2010, a position he still
          holds.</p>
        <p>He helped establish the European Fencing Confederation in 1991 and served on
          its board for 17 years, including being secretary-general, first
          vice-president, treasurer and SEMI Commission president. Several world and
          European championships have been organised in the Netherlands from 1985 to
          1995 thanks to Mr. van de Flier’s efforts, who is also credited with being
          instrumental in helping the Airborne Trophy and Zoetermeer Trophy competitions
          become (former) FIE World Cups in the Netherlands.</p>
      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim
            .fromTo(cOf("45-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("45-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        function togglePage45(show, hide) {
          var show = idOf(show)
          var hide = cOf(hide)
          TweenMax.to(hide, 0.01, {opacity: 0});
          TweenMax.to(show, 0.01, {opacity:1});
        }
        function onPageLeave() {
          pg45Anim.stop();
          resetNumbers("45-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "FIE  INSIDE FENCING Bert M.J. van de Flier (NED, MH) Given Royal Decoration from the Netherlands Click to read more here  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.fencewithfun.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 259px; right: 22px; width: 33px; height: 154px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://www.fencewithfun.com" target="_blank">
          <img src="/120/en/static/_content/46-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 47-title" style="top:195px;left:65px;" src="/120/en/static/_content/47-title-1.png">
        <img class="abs halfScale 47-sub" style="top:388px;left:92px;" src="/120/en/static/_content/47-sub-1.png">
        <img class="abs halfScale 47-line" style="top:390px;left:64px;" src="/120/en/static/_content/47-line-1.png">
        <img id="47-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-green.png">
      `,
      "mobileHtml": `
        <h2 id="togo-hosts-fencing-equipment-repair-course">Togo hosts fencing equipment
          repair course</h2>
        <img src="/120/en/static/_content/47-mobile-1.jpg">
        <p><strong>Lomé, Togo<br>14 January 2022</strong></p>
        <p><strong>The Togolese Fencing Federation hosted a fencing equipment repair
            course from Dec. 14-18, 2021 with 14 trainees from four fencing leagues in
            the region. </strong></p>
        <p>The course, held at the request of Federation President Victor Laméga, was
          funded by the FIE, which provided expert instruction, equipment and tools.</p>
        <p>Mr. Gilles Martinage (FRA), who has worked as an official armourer and
          managed weapons control in numerous events worldwide, led the preparation and
          training of the course.</p>
        <p>The 14 trainees had varying levels of experience, including athletes,
          coaches, fencing masters trained in Dakar or Algiers, athletes training to be
          coaches, and the international referee and technical director of the Togolese
          Federation, Mr. Koffi Kassefon.</p>
        <p>Theoretical and informational content was provided about electrical scoring
          systems, technical aspects of weapons operation and current equipment
          regulations. Topics covered included fault detection, complete weapon repair
          and assembly, verification of piste installations and proper personal gear
          verification (e.g., lames, body wires, masks, etc.).</p>
        <p>The course overall was interactive and hands-on, focused on developing and
          practicing technical skills. Daily content addressed the individual interests,
          skills and expectations of the trainees and focused on ensuring they developed
          the ability to consistently reproduce the techniques they learned. Practical
          exercises took place using the equipment provided by the FIE: 12 basic repair
          kits, three armourer cases and a special kit for repairing cable spools. The
          focus of these exercises was to effectively recondition competition weapons,
          standardizing body wires, spool repair, managing piste cables and
          repairing/managing scoring apparatus and associated remote controls. Trainees
          learned to test all equipment, test and detect faults and determine proper and
          necessary repairs and apply the repairs, including soldering, bonding wires to
          blades and restoring metallic threads for proper conductivity.</p>
        <p>The results of the course included trainees being able to effectively assess
          and repair virtually all FIE competition weapons, test and repair body cords
          and cable spools, repair remotes for scoring systems and craft cables designed
          to connect cable spools to weapons.</p>
        <p>When participation certificates were presented to trainees, Mr. Martinage
          hailed their enthusiasm, outstanding work and conscientiousness throughout the
          course. Togolese Federation President Laméga also welcomed the “spirit of
          cohesion” that prevailed during the programme.</p>
      `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim
            .fromTo(cOf("47-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("47-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("47-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("47-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg47Anim.stop();
          resetNumbers("47-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "FIE & NATIONAL FEDER ATION NE WS  TOGO HOSTS FENCING EQUIPMENT REPAIR COURSE LOMÉ, TOGO JANUARY 14, 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-green.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-green.png">
        </a>

        <img id="48-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-edge-green.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim
            .fromTo(idOf("48-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg48Anim.stop();
          resetNumbers("48-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 3  The Togolese Fencing Federation hosted a fencing equipment repair course from Dec. 14-18, 2021 with 14 trainees from four fencing leagues in the region. The course, held at the request of Federation President Victor Laméga, was funded by the FIE, which provided expert instruction, equipment and tools. Mr. Gilles Martinage (FRA), who has worked as an official armourer and managed weapons control in numerous events worldwide, led the preparation and training of the course.  The 14 trainees had varying levels of experience, including athletes, coaches, fencing masters trained in Dakar or Algiers, athletes training to be coaches, and the international referee and technical director of the Togolese Federation, Mr. Koffi Kassefon. Theoretical and informational content was provided about electrical scoring systems, technical aspects of weapons operation and current equipment regulations. Topics covered included fault detection, complete weapon repair and assembly, verification of piste installations and proper personal gear verification (e.g., lames, body wires, masks, etc.). The course overall was interactive and hands-on, focused on developing and practicing technical skills. Daily content addressed the individual interests, skills and expectations of the trainees and focused on ensuring they developed the ability to consistently reproduce the techniques they learned. Practical exercises took place using the equipment provided by the FIE: 12"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/en/static/_content/tw-green.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/en/static/_content/fb-green.png">
        </a>

        <img id="49-next" class="halfScale pointer" style="top:647px;right:-79px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-pad-green.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim
            .fromTo(idOf("49-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg49Anim.stop();
          resetNumbers("49-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "determine proper and necessary repairs and apply the repairs, including soldering, bonding wires to blades and restoring metallic threads for proper conductivity.  FIE & NATIONAL FEDERATION NEWS 3 OF 3  The results of the course included trainees being able to effectively assess and repair virtually all FIE competition weapons, test and repair body cords and cable spools, repair remotes for scoring systems and craft cables designed to connect cable spools to weapons. basic repair kits, three armourer cases and a special kit for repairing cable spools. The focus of these exercises was to effectively recondition competition weapons, standardizing body wires, spool repair, managing piste cables and repairing/managing scoring apparatus and associated remote controls. Trainees learned to test all equipment, test and detect faults and  When participation certificates were presented to trainees, Mr. Martinage hailed their enthusiasm, outstanding work and conscientiousness throughout the course. Togolese Federation President Laméga also welcomed the “spirit of cohesion” that prevailed during the programme. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/en/static/_content/50-mobile-1.jpg">
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 51-title" style="top:67px;left:63px;" src="/120/en/static/_content/51-title-1.png">

        <img id="51-next" class="halfScale pointer" style="top:718px;right:-243px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-long-orange.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div class="contentLink" onclick="showOverlay('51-popups-1')" style="bottom: 256px; right: 838px; width: 71px; height: 27px;"></div>
        <div class="contentLink" onclick="showOverlay('51-popups-2')" style="bottom: 500px; right: 288px; width: 51px; height: 23px;"></div>

        <div id="51-popups-1" class="standardTransition contentOverlay hidden noclick">
          <img id="51-pop-2-1" class="halfScale 51-popup-2" src="/120/en/static/_content/51-popup-1-1.png" alt="">
          <div class="contentLink" style="top: 40px; left: 1040px; width: 35px; height: 35px;"
            onclick="hideOverlay('51-popups-1');"></div>  
        </div>
        <div id="51-popups-2" class="standardTransition contentOverlay hidden noclick">
          <img id="51-pop-2-1" class="halfScale 51-popup-2A" src="/120/en/static/_content/51-popup-2-1.png" alt="">
          <img id="51-pop-2-2" class="halfScale 51-popup-2" src="/120/en/static/_content/51-popup-2-2.png" style="opacity:0" alt="">
          <div class="contentLink" style="top: 798px; left: 600px; width: 125px; height: 48px;"
            onclick="togglePage51('51-pop-2-1', '51-popup-2');"></div>
          <div class="contentLink" style="top: 798px; left: 755px; width: 125px; height: 48px;"
            onclick="togglePage51('51-pop-2-2', '51-popup-2');"></div>
          <div class="contentLink" style="top: 40px; left: 1040px; width: 35px; height: 35px;"
            onclick="hideOverlay('51-popups-2');"></div>
        </div>
      `,
      "mobileHtml": `
        <h2 id="fie-news">FIE NEWS</h2>
        <p><strong>1<br>IOC Athlete365 Career+ “Power-Up’’ workshop</strong></p>
        <img src="/120/en/static/_content/51-mobile-1.jpg">
        <p><strong>Prior to the start of the 2022 Junior and Cadet Fencing World
            Championships in Dubai, United Arab Emirates, an IOC Athlete365 Career+
            ‘’Power-Up’’ workshop was held for fencers taking part in an official FIE
            training camp.</strong></p>
        <p>The workshop was led by three-time Olympian and FIE digital communication
          manager Maria Ntanou, with 16 fencers participating from 16 countries.</p>
        <p>The half-day workshop covered several modules, such as how to identify your
          strengths and values.</p>
        <p>The workshop teaches that no matter what stage your career is in, it is
          important to take time to reflect and evaluate who you are and what you want
          out of life. Finding what your superpowers are and what truly motivates and
          drives you will help in all aspects of your career and life.</p>
        <p>This first session focused on self-reflection and activities among athletes’
          groups to answer questions like: “What is great about me?”, “What could I be
          better at?” and “What is important to me?”</p>
        <p>At the end of the session fencers were able to distinguish three of their top
          personality trait strengths and three areas they could develop further.</p>
        <p><strong>2<br>FIE Supports April 6 International Day of Sport for Development
            and Peace at Dubai Junior and Cadet Fencing World Championships</strong></p>
        <img src="/120/en/static/_content/51-mobile-2.jpg">
        <p><strong>Today is the International Day of Sport for Development and Peace
            (IDSDP), designated by the United Nations General Assembly, a movement
            supported by the FIE.</strong></p>
        <p>Each year, on April 6, the world of sport highlights the unique power of
          sport in supporting people and communities to overcome adversity and
          contribute significantly as a crucial enabler of sustainable development. It
          recognises sports activities and their positive impact on peace and harmony in
          the co-existence of communities worldwide.</p>
        <p>The 2022 IDSDP theme is “Securing a Sustainable and Peaceful Future for All:
          The Contribution of Sport”. Using sport as a key component to ensure a
          sustainable future for mankind, the current focus is on climate change and
          diminishing greenhouse gas emissions.</p>
        <p>At the Junior and Cadet Fencing World Championships, taking place from April
          2 to 10 in Dubai, United Arab Emirates, athletes were briefed on the IDSDP and
          as is the organisation’s hallmark symbol, asked to hold white cards.</p>
        <p>They are a reference to the yellow and red penalty cards in the sporting
          world, and since 2014 a #WhiteCard is a symbol created by the organisation
          “Peace and Sport”, representing the positive power of sport for peace and
          social inclusion. International teen athletes participating in the Junior and
          Cadet Fencing World Championships from all three fencing weapons (epee, foil,
          sabre) and both genders provided their thoughts on the April 6 initiative:</p>
        <p>“ Sports is a way to bond with something we all have in common. There are
          thousands of fencers here who are setting-aside their differences to compete.
          Of course, we cannot do that without peace.”
          Jakob Lars Kristmannson (ISL)</p>
        <p>“ Peace and sport unifies people even though there’s competition. There’s a
          level of sportsmanship and understanding, so it’s a great way to bring people
          together.”
          Sanojah Gilkes (BAR)</p>
        <p>“ Sports like fencing bring people together; they want to compete but also
          want to show companionship. As a sportsman, even though you are fighting, you
          want to be sure be peaceful when not in competition, to bring each other
          closer and provide feedback to one another.”
          Daniella Weng Yan Tang (SGP)</p>
        <p>According to the Peace and Sport organisation, “Through a #WhiteCard, each of
          us can advocate on the unique power of sport for social development and peace
          and share a story on how sport supported us to overcome challenges.”</p>
      `,
      "script": `
        function onPageEnter() {
          pg51Anim = new TimelineMax();
          pg51Anim
            .fromTo(cOf("51-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("51-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        function togglePage51(show, hide) {
          var show = idOf(show)
          var hide = cOf(hide)
          TweenMax.to(hide, 0.01, {opacity: 0});
          TweenMax.to(show, 0.01, {opacity:1});
        }
        function onPageLeave() {
          pg51Anim.stop();
          resetNumbers("51-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NE WS  FIE NEWS  WWW.FIE.ORG  2  FIE Supports International Day of Sport for Development and Peace See more here.  1  IOC Athlete365 Career+ “Power-Up’’ workshop See more here.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:jason@jiangfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 76px; right: 352px; width: 235px; height: 19px;"></div>
        </a>
        <a href="http://www.jiangfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 97px; right: 377px; width: 211px; height: 17px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="http://www.jiangfencing.com" target="_blank">
          <img src="/120/en/static/_content/52-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 53-title" style="top:67px;left:58px;" src="/120/en/static/_content/53-title-1.png">

        <img id="53-next" class="halfScale pointer" style="top:719px;right:-184px" onclick="Publish.goToNextPage()"
          src="/120/en/static/_content/arrow-long-navy.png">
        
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="53-1" class="abs noOverflow 53-div" style="top:299px; left: 65px; height: 520px; width: 810px; display: block;">
          <img id="53-text-1a" class="halfScale 53-text-1" style="top:0px;left:0px;"
            src="/120/en/static/_content/53-text-1-1.png">
          <img id="53-text-1b" class="halfScale 53-text-1" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-1-2.png">
          <div id="53-btn-1a" class="abs halfScale pointer 53-btn-1"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-1a', '53-btn-1', '53-text-1a', '53-text-1')"></div>
          <div id="53-btn-1b" class="abs halfScale pointer 53-btn-1"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-1b', '53-btn-1', '53-text-1b', '53-text-1')"></div>
        </div>
        
        <div id="53-2" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-2a" class="halfScale 53-text-2" style="top:0px;left:0px;"
            src="/120/en/static/_content/53-text-2-1.png">
          <img id="53-text-2b" class="halfScale 53-text-2" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-2-2.png">
          <div id="53-btn-2a" class="abs halfScale pointer 53-btn-2"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-2a', '53-btn-2', '53-text-2a', '53-text-2')"></div>
          <div id="53-btn-2b" class="abs halfScale pointer 53-btn-2"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-2b', '53-btn-2', '53-text-2b', '53-text-2')"></div>
        </div>
        
        <div id="53-3" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-3a" class="halfScale 53-text-3" style="top:0px;left:0px;"
            src="/120/en/static/_content/53-text-3-1.png">
          <img id="53-text-3b" class="halfScale 53-text-3" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-3-2.png">
          <div id="53-btn-3a" class="abs halfScale pointer 53-btn-3"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-3a', '53-btn-3', '53-text-3a', '53-text-3')"></div>
          <div id="53-btn-3b" class="abs halfScale pointer 53-btn-3"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-3b', '53-btn-3', '53-text-3b', '53-text-3')"></div>
        </div>
        
        <div id="53-4" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-4a" class="halfScale 53-text-4" style="top:0px;left:0px;"
            src="/120/en/static/_content/53-text-4-1.png">
          <img id="53-text-4b" class="halfScale 53-text-4" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-4-2.png">
          <img id="53-text-4c" class="halfScale 53-text-4" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-4-3.png">
          <div id="53-btn-4a" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-4a', '53-btn-4', '53-text-4a', '53-text-4')"></div>
          <div id="53-btn-4b" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-4b', '53-btn-4', '53-text-4b', '53-text-4')"></div>
          <div id="53-btn-4c" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-4c', '53-btn-4', '53-text-4c', '53-text-4')"></div>
        </div>
        
        <div id="53-5" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-5a" class="halfScale 53-text-5" style="top:0px;left:0px;"
            src="/120/en/static/_content/53-text-5-1.png">
          <img id="53-text-5b" class="halfScale 53-text-5" style="top:0px;left:0px; opacity:0;;"
            src="/120/en/static/_content/53-text-5-2.png">
          <img id="53-text-5c" class="halfScale 53-text-5" style="top:0px;left:0px; opacity:0;;"
            src="/120/en/static/_content/53-text-5-3.png">
          <div id="53-btn-5a" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-5a', '53-btn-5', '53-text-5a', '53-text-5')"></div>
          <div id="53-btn-5b" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-5b', '53-btn-5', '53-text-5b', '53-text-5')"></div>
          <div id="53-btn-5c" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-5c', '53-btn-5', '53-text-5c', '53-text-5')"></div>
        </div>
        
        <div id="53-6" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-6a" class="halfScale 53-text-6" style="top:0px;left:0px;"
            src="/120/en/static/_content/53-text-6-1.png">
          <img id="53-text-6b" class="halfScale 53-text-6" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-6-2.png">
          <img id="53-text-6c" class="halfScale 53-text-6" style="top:0px;left:0px; opacity:0;"
            src="/120/en/static/_content/53-text-6-3.png">
          <div id="53-btn-6a" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-6a', '53-btn-6', '53-text-6a', '53-text-6')"></div>
          <div id="53-btn-6b" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-6b', '53-btn-6', '53-text-6b', '53-text-6')"></div>
          <div id="53-btn-6c" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-6c', '53-btn-6', '53-text-6c', '53-text-6')"></div>
        </div>
        
        <img id="53-cta-1" class="halfScale pointer 53-btn" style="top:258px;left:869px;transform:scale(0.506,0.52);"
          onclick="pg53Toggle('53-1', '53-cta-1');" src="/120/en/static/_content/53-name-1.png">
        <img id="53-cta-2" class="halfScale pointer 53-btn" style="top:325px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-2', '53-cta-2');" src="/120/en/static/_content/53-name-2.png">
        <img id="53-cta-3" class="halfScale pointer 53-btn" style="top:393px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-3', '53-cta-3');" src="/120/en/static/_content/53-name-3.png">
        <img id="53-cta-4" class="halfScale pointer 53-btn" style="top:461px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-4', '53-cta-4');" src="/120/en/static/_content/53-name-4.png">
        <img id="53-cta-5" class="halfScale pointer 53-btn" style="top:528px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-5', '53-cta-5');" src="/120/en/static/_content/53-name-5.png">
        <img id="53-cta-6" class="halfScale pointer 53-btn" style="top:595px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-6', '53-cta-6');" src="/120/en/static/_content/53-name-6.png">
      `,
      "mobileHtml": `
        <h2 id="obituaries">Obituaries</h2>
        <p><strong>1<br>JAHANGIR SAFAROV (AZE)</strong></p>
        <img src="/120/en/static/_content/53-mobile-1.png">
        <p><strong>The FIE is saddened to learn of the passing of Jahangir Safarov (AZE)
            on 12 November.</strong></p>
        <p>He was a coach of the Azerbaijan national fencing team as well as a national
          referee. He was born on 9 March 1968. Safarov began fencing at age 10. He
          became a medallist at numerous USSR competitions and participated in World and
          European Championships and was named a USSR Master of Sports in 1985.</p>
        <p>He became a coach of the Azerbaijan national team in 2001, producing several
          national champions as well as medallists at international and regional
          competitions, and was the head coach for cadet women’s sabre. Safarov’s
          student, Zarifa Huseynova, took the bronze medal in individual cadet women’s
          sabre at the 2021 Cairo Junior and Cadet Fencing World Championships. His son,
          Javanshir Safarov, whom he also coached, took silver in men’s sabre at the
          Tehran Junior World Cup in December 2013.</p>
        <p>On behalf of the world fencing family, the FIE offers sincere condolences to
          Jahangir Safarov’s family and friends, the Azerbaijan Fencing Federation and
          the European Fencing Confederation, and we express our deepest sympathy during
          this difficult time.</p>
        <p><strong>2<br>ALEX ORBAN (USA)</strong></p>
        <img src="/120/en/static/_content/53-mobile-2.png">
        <p><strong>The FIE is saddened to learn of the passing of Alex Orban (USA) on 2
            December at age 82, a three-time Olympic sabreur.</strong></p>
        <p>He was born on August 25, 1939 in Budapest, Hungary and began fencing when he
          was 14. By age 16 he was the youngest fencer ever to have achieved a
          first-class ranking in Hungary and labelled the “coming star of the Magyar
          squads”.</p>
        <p>Mr. Orban moved to the USA and after serving three years in the U.S.
          military, he trained and competed in fencing. He became a member of the U.S.
          Olympic fencing team at the 1968 (Mexico City), 1972 (Munich) and 1976
          (Montreal) Olympic Games.</p>
        <p>He was U.S. national sabre champion in 1965 and every year from 1969 to 1972,
          and individual sabre champion at the 1971 Pan American Games in Cali,
          Colombia. Mr.Orban also won men’s team sabre silver medals at the Pan American
          Games in 1971 and 1975 (Mexico City). He was the first U.S. sabre fencer to
          win an international “A”-rated event in 1968 in Lodz, Poland.</p>
        <p>Mr. Orban was inducted into the USA Fencing Hall of Fame in 1999.</p>
        <p>On behalf of the world fencing family, the FIE offers sincere condolences to
          Alex Orban’s family and friends, USA Fencing and the Pan American Fencing
          Confederation, and we express our deepest sympathy during this difficult time.
        </p>
        <p><strong>3<br>ALI YOUSSEF HUSSAIN (KUW, MH)</strong></p>
        <img src="/120/en/static/_content/53-mobile-3.png">
        <p><strong>The FIE is saddened to learn of the passing on 26 December of Ali
            Youssef Hussain (KUW), an FIE Member of Honour and member of the Hall of
            Fame. He was born in 1938.</strong></p>
        <p>A former member of the FIE Executive Committee (2001-2008), Mr. Hussain was
          made a Member of Honour by the Congress in 2008. From 1985 to 2004, he was a
          member of the FIE Propaganda Commission (now named the Promotion,
          Communication and Marketing Commission).</p>
        <p>In 1977, he was elected as a member of the Kuwait Amateur Fencing
          Association, serving over time as their president for eight years as well as a
          member of the Board of Directors and Technical Committee, and the
          organisation’s manager of products. Mr. Hussain was a member of the Kuwait
          National Olympic Committee Board of Directors, serving as its
          secretary-treasurer from 1994 to 2014.</p>
        <p>Involved in several sports from a young age, Mr. Hussain was for many years a
          member of the Yarmouk Sports Club beginning in 1965, the year it was founded.
          He was a member of its board of directors for 10 years and served as its
          secretary-general and president.</p>
        <p>Among various educational programmes, Mr. Hussain attended an academic
          international Olympic course in sports management in 1987. He also studied
          management and sports science under the supervision of the Arab Sports
          Federation, which as of 1988 enabled him to pursue his career in sports
          administration.</p>
        <p>The FIE offers its sincere condolences and expresses its deepest sympathy to
          Ali Youssef Hussain’s family and friends, the Kuwait Fencing Amateur Fencing
          Association and the Asian Fencing Confederation.</p>
        <p><strong>4<br>OLGA ORBAN-SZABOV (ROU)</strong></p>
        <img src="/120/en/static/_content/53-mobile-4.png">
        <p><strong>The FIE is saddened to learn of the passing on January 5 of Olga
            Orban- Szabo (ROU), multiple-time Olympic medallist and world champion and a
            member of the FIE Hall of Fame. </strong></p>
        <p>Born on October 9, 1938 in Cluj, Ms. Szabo was the first Olympic medallist
          and world champion for Romania, and competed in five Olympic Games (Melbourne
          1956, Rome 1960, Tokyo 1964, Mexico City 1968 and Munich 1972). She earned her
          first Olympic medal, a silver in women’s individual foil, in Melbourne, and
          then a bronze in women’s team foil in both the Mexico City and Munich Games.
        </p>
        <p>She became individual women’s foil world champion at the 1962 Buenos Aires
          World Championships. As part of the Romanian women’s foil team (including
          Maria Vicol, Ileana Gyulai, Ecaterina Stahl and Ana Pascu), she took a gold
          medal at the 1969 Havana World Championships, another first for her country.
        </p>
        <p>In all, Ms. Orban-Szabo earned 11 Olympic and World Championships medals in
          women’s foil, including three from the Olympic Games and eight at the World
          Championships between 1961 and 1970. Prior to that, she was a junior world
          silver medallist in 1959.</p>
        <p>She also won three medals at the Universiade, including individual silver and
          team gold in 1961 and team silver in 1965. As member of the army club “Steaua
          Bucarest”, she won the Romanian national championship seven times, and was
          awarded the national title of “Emeritus Master of Sport” as well as numerous
          Romanian orders and titles. She graduated from the Babes-Bolyai University in
          Cluj-Napoca and was also a fencing master. Following her retirement from
          competition in 1972, she worked as a youth fencing coach at her club in
          Bucharest.</p>
        <p>“She was a distinguished Lady of the Romanian fencing team”, stated Marius
          Florea, Romanian Federation President. “The Romanian Fencing Federation would
          like to express its deep gratitude for Mrs. Olga Orban-Szabo’s contribution to
          the foundation of the Romanian fencing family.” The FIE offers its sincere
          condolences and expresses its deepest sympathy to Olga Orban-Szabo’s family
          and friends, the Romanian Fencing Federation and the European Fencing
          Confederation.</p>
        <p><strong>5<br>JOSE VALARINHO (POR)</strong></p>
        <img src="/120/en/static/_content/53-mobile-5.png">
        <p><strong>The FIE is saddened to learn of the passing of Jose Valarinho (POR),
            member of the FIE Hall of Fame, on March 30, 2022, at the age of 87. He was
            a member of the FIE Disciplinary Commission from 1996 to 2004.</strong></p>
        <p>He was awarded a special FIE gold medal three times for his academic work on
          fencing as well as organising the 1988 FIE Congress in Madeira and the 2002
          Lisbon World Championships. He also received the Olympic Order of the
          Portuguese Olympic Committee and the Medal for Sports Merits by the Portuguese
          government.</p>
        <p>Mr. Valarinho was president of the Portuguese Fencing Federation for two
          terms beginning in 1992. He joined the organisation in 1969 as president of
          the Technical Commission, and over several decades he had a significant impact
          on the growth and development of fencing in Portugal. He participated in a
          “Plan for the Development of Sports” with a special program, “500 Foils”, and
          worked to support Portugal becoming more active in international fencing.</p>
        <p>Mr. Valarinho took part in organising the first European Championships in
          Lisbon, 1983, as well as multiple other continental and world competitions
          held in Portugal during the 1980s and 1990s. His vision for Portuguese
          becoming a strong participant in world fencing was realised fully when his
          country’s men’s foil team won the gold medal at the 2000 European
          Championships in Madeira. After his departure from the presidency, he
          successfully organised the 2002 Lisbon Fencing World Championships.</p>
        <p>Having a traditional Portuguese military education, Mr. Valarinho ultimately
          became an Army officer, and it was during his schooling where he first
          experienced fencing along with becoming a skilled equestrian. He graduated
          with honours as a maître at the Military Sports Center in Mafra, where he was
          a competitive fencer and took part in the 1959 Universiade as a member of the
          men’s sabre team. Following school, he became a fencing master, specialised in
          recruiting and developing young fencers. He was the author of two books on the
          history of Portuguese fencing and was in the process of preparing a third
          edition.</p>
        <p>“He was a fencer to his dying day”, said his son, Frederico Valarinho, who
          has been a member of the Portuguese Fencing Federation since 2006. The FIE
          extends its sincere condolences to Jose Valarinho’s family and friends, the
          Portuguese Fencing Federation and the European Fencing Confederation. We
          express our deepest sympathy to them during this difficult time.</p>
        <p><strong>ANA PASCU (ROU, MH)</strong></p>
        <img src="/120/en/static/_content/53-mobile-6.png">
        <p>Elected in 2000, Ms. Pascu served as a member of the FIE Executive Committee,
          including being vice president from 2004 to 2021. Prior to that, she was a
          member of the FIE Rules Commission from 1984 to 1988</p>
        <p>The FIE is deeply saddened to learn of the passing in Bucharest on April 6,
          2022, of Ms. Ana Pascu (ROU), FIE Member of Honour and Hall of Fame member.
          She was born on September 22, 1944 and of the FIE Refereeing Commission from
          1988 to 1996. She was also an FIE international referee in foil and epee.</p>
        <p>She holds the record as the longest-serving president of a Romanian Fencing
          Federation. From 1982 to 2013, Ms. Pascu headed the Federation, contributing
          to the sporting achievements of Romanian fencers who won 134 medals during her
          tenure, including nine at the Olympic Games, 57 at the World Championships and
          68 at the European Championships. Following her retirement as president, she
          was appointed honorary president of the Romanian Fencing Federation.</p>
        <p>She was also vice president of the Romanian Olympic and Sports Committee. As
          an athlete, Ms. Pascu was a five-time Olympic foilist, and in team foil she
          won a bronze medal at the 1968 and 1972 Olympic Games and the gold medal at
          the 1969 Havana World Championships. In individual foil, she won the Junior
          World Championships in 1963 as well as the bronze medal at the 1971 World
          Championships. As part of the Romanian Women’s Foil Team, she won the team
          foil silver medal at the 1970 World Championships and bronze medals at the
          1961, 1967, 1971, 1973, 1974 and 1975 World Championships. In 1961 and 1965,
          her team won gold and silver, respectively, at the World University Games
          (“Universiade”).</p>
        <p>Ms. Pascu also had a career as a fencing coach and physical education teacher
          until 1982, having earned a doctorate in physical education and sport. Her
          doctoral thesis was titled The Strategy for Enhancing Sports Preparation in
          Competitions. She also held a “Doctor Honoris Causa” from Vasile Goldis
          University in Romania. She authored numerous scientific and sports
          publications and was awarded several titles and decorations, including the
          National Order of Merit in the rank of Officer and Knight. </p>
        <p>Ms. Pascu dedicated her entire life to fencing, fencers, Romanian Fencing and
          the FIE, and the many successes resulting from this are testament to her
          incredible talent and passion for our sport. In the words of Emmanuel
          Katsiadakis, FIE Interim President, “She tirelessly, generously and with
          infinite kindness helped, supported and motivated all those who sought her
          help and advice. She was an outstanding mentor and role model for athletes,
          officials and leaders in fencing, as well as for girls and women in sport. The
          fencing family has lost a great lady and an emblematic personality with rare
          and invaluable human and professional qualities. She will remain in our
          memories, in our hearts and in our history.”</p>
        <p>The FIE extends its sincere condolences for their loss to Ms. Pascu’s sister
          Nicoleta, her family and friends, the Romanian Fencing Federation and the
          European Fencing Confederation, and expresses its deepest sympathy during this
          difficult time.</p>
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax();
          pg53Anim
            .to(idOf("53-1"), 0.3,{display: 'block'}, 0)
            .fromTo(cOf("53-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("53-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function pg53Toggle(id, btn) {
          var ele = idOf(id)
          var but = idOf(btn)
          TweenMax.to(cOf("53-div"), 0.01, {display: 'none'});
          TweenMax.to(cOf("53-btn"), 0.01, {opacity: 0});
          TweenMax.to(ele, 0.1, {display: 'block'});
          TweenMax.to(but, 0.1, {opacity: 1});
        }
        
        function togglePage(id, klass, text, texttwo) {
          var ele = idOf(id)
          var but = cOf(klass)
          var txt = idOf(text)
          var txt2 = cOf(texttwo)
          TweenMax.to(but, 0.01, {opacity: 0});
          TweenMax.to(txt2, 0.01, {opacity: 0});
          TweenMax.to(ele, 0.01, {opacity:1});
          TweenMax.to(txt, 0.01, {opacity:1});
        }
        
        function onPageLeave(){
          pg53Toggle('53-text-1', '53-cta-1');
          togglePage('53-btn-1', '53-btn-2', '53-text-1', '53-text-1');
          pg53Anim.stop();
          resetNumbers("53-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "REMEMBR ANCE  OBITUARIES JAHANGIR SAFAROV  JAHANGIR SAFAROV (AZE) and European Championships and was named a USSR Master of Sports in 1985.  The FIE is saddened to learn of the passing of Jahangir Safarov (AZE) on 12 November. He was a coach of the Azerbaijan national fencing team as well as a national referee. He was born on 9 March 1968. Safarov began fencing at age 10. He became a medallist at numerous USSR competitions and participated in World  He became a coach of the Azerbaijan national team in 2001, producing several national champions as well as medallists at international and regional competitions, and was the head coach for cadet women’s sabre. Safarov’s student, Zarifa Huseynova, took the bronze medal in individual cadet women’s sabre at the 2021 Cairo Junior and Cadet Fencing World Championships. His son, Javanshir Safarov, whom he also  ALEX ORBAN  ALI YOUSSEF HUSSAIN  OLGA ORBAN-SZABO  JOSE VALARINHO  ANA PASCU  s Click Above to View  1  2  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
        <a href="http://www.gfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 186px; right: 599px; width: 228px; height: 38px;"></div>
        </a>
        <a href="mailto:sales@gfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 186px; right: 340px; width: 236px; height: 38px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="http://www.gfencing.com" target="_blank">
          <img src="/120/en/static/_content/54-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))
        
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) { 
          return e.className = 'addContentLinkThree'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": [
      {
        title: "Escrime XXI No. 120",
        link: "Escrime XXI No. 120",
        cssClass: "cover mobile-p1",
        hideInMenu: false,
        pageLinks: [
          {
            index: 0,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 2,
            subIndex: 0
          }
        ]
      },
      {
        title: "Comex",
        link: "Comex",
        cssClass: "blue",
        hideInMenu: false,
        pageLinks: [
          {
            index: 4,
            subIndex: 0
          }
        ]
      },
      {
        title: "Foreword",
        link: "Foreword",
        cssClass: "darkblue",
        hideInMenu: false,
        pageLinks: [
          {
            index: 5,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 6,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Tashkent",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 7,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Orleans",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 9,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 12,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Tallinn",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 13,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Bern",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 16,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 18,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | St Maur",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 19,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Paris",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 21,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 23,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Poznan",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 24,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Tbilisi",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 26,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 29,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Plovdiv",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 30,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Doha",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 32,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Budapest",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 34,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 37,
            subIndex: 0
          }
        ]
      },
      {
        title: "Sport",
        link: "Sport | Dubai",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 38,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 43,
            subIndex: 0
          }
        ]
      },
      {
        title: "FIE",
        link: "Inside Fencing",
        cssClass: "pink",
        hideInMenu: false,
        pageLinks: [
          {
            index: 44,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 45,
            subIndex: 0
          }
        ]
      },
      {
        title: "FIE & National Federation News",
        link: "FIE & National Federation News | Togo",
        cssClass: "green",
        hideInMenu: false,
        pageLinks: [
          {
            index: 46,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 49,
            subIndex: 0
          }
        ]
      },
      {
        title: "News",
        link: "FIE News",
        cssClass: "orange",
        hideInMenu: false,
        pageLinks: [
          {
            index: 50,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 51,
            subIndex: 0
          }
        ]
      },
      {
        title: "Rememberance",
        link: "Obituaries",
        cssClass: "grey",
        hideInMenu: false,
        pageLinks: [
          {
            index: 52,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 53,
            subIndex: 0
          }
        ]
      },
    ],
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js